import "core-js/modules/es7.object.entries";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.string.anchor";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.string.strike";
import "core-js/modules/es6.string.link";
import "core-js/modules/es6.string.ends-with";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.string.repeat";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.array.some";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.define-property";
import React__default, { createElement, useRef, useCallback, createContext, useContext, useState, useEffect, Fragment, Component, createRef, useLayoutEffect } from 'react';
import styled, { css, keyframes } from 'styled-components';
import { DecorationSet, Decoration, EditorView } from 'prosemirror-view';
import { Schema, Mark, DOMSerializer as DOMSerializer$1, DOMParser as DOMParser$1, Fragment as Fragment$1, Slice } from 'prosemirror-model';
import { tableNodes, goToNextCell, CellSelection, TableMap, tableEditing, deleteColumn, deleteRow, deleteTable } from 'prosemirror-tables';
import { PluginKey, Plugin, TextSelection, Selection, NodeSelection, EditorState } from 'prosemirror-state';
import { dropCursor } from 'prosemirror-dropcursor';
import { gapCursor } from 'prosemirror-gapcursor';
import { undo, redo, history, undoDepth, redoDepth } from 'prosemirror-history';
import { keymap } from 'prosemirror-keymap';
import { toggleMark, setBlockType, wrapIn, chainCommands, exitCode, baseKeymap, createParagraphNear, liftEmptyBlock, splitBlock } from 'prosemirror-commands';
import { liftListItem, wrapInList, splitListItem, sinkListItem } from 'prosemirror-schema-list';
import { findParentNodeOfType, forEachCellInColumn, setCellAttrs, addColumnAt, addRowAt, getCellsInRow } from 'prosemirror-utils';
import { undoInputRule, wrappingInputRule, textblockTypeInputRule, InputRule, inputRules as inputRules$1 } from 'prosemirror-inputrules';
import { liftTarget } from 'prosemirror-transform';
import { Dismissible } from 'react-dismissible';
import { Button, TinaReset, IconButton } from '@tinacms/styles';
import { Input } from '@tinacms/fields';
import { MediaIcon, CloseIcon, UploadIcon, CodeIcon, BoldIcon, ItalicIcon, StrikethroughIcon, LinkIcon, TableIcon, AlignLeft, AlignCenter, AlignRight, TrashIcon, AddIcon, HeadingIcon, UndoIcon, RedoIcon, UnorderedListIcon, OrderedListIcon, QuoteIcon } from '@tinacms/icons';
import ReactDOM__default, { createPortal } from 'react-dom';
import debounce from 'lodash.debounce';
import { LoadingDots } from '@tinacms/react-forms';

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

/**
 * code
 */


var code = {
  parseDOM: [{
    tag: 'code'
  }],
  toDOM: function toDOM() {
    return ['code'];
  }
};
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

/**
 * Emphasis
 */

var em = {
  parseDOM: [{
    tag: 'i'
  }, {
    tag: 'em'
  }, {
    style: 'font-style',
    getAttrs: function getAttrs(value) {
      return value === 'italic' && null;
    }
  }],
  toDOM: function toDOM() {
    return ['em'];
  }
};
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

/**
 * Link
 */

var link = {
  attrs: {
    href: {},
    title: {
      "default": null
    }
  },
  inclusive: false,
  parseDOM: [{
    tag: 'a[href]',
    getAttrs: function getAttrs(dom) {
      return {
        href: dom.getAttribute('href'),
        title: dom.getAttribute('title')
      };
    }
  }],
  toDOM: function toDOM(node) {
    return ['a', node.attrs];
  },
  toDocument: function toDocument(node) {
    return ['a', node.attrs];
  }
};
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

/**
 * strikethrough
 */

var strike = {
  parseDOM: [{
    tag: 'strike'
  }, {
    tag: 's'
  }, {
    tag: 'del'
  }, {
    style: 'text-decoration',
    getAttrs: function getAttrs(value) {
      return value === 'line-through' && null;
    }
  }],
  toDOM: function toDOM() {
    return ['s', 0];
  }
};
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

/**
 * strong
 */

var strong = {
  parseDOM: [{
    tag: 'strong'
  }, // This works around a Google Docs misbehavior where
  // pasted content will be inexplicably wrapped in `<b>`
  // tags with a font-weight normal.
  {
    tag: 'b',
    getAttrs: function getAttrs(node) {
      return node.style.fontWeight != 'normal' && null;
    }
  }, {
    style: 'font-weight',
    getAttrs: function getAttrs(value) {
      return /^(bold(er)?|[5-9]\d{2,})$/.test(value) && null;
    }
  }],
  toDOM: function toDOM() {
    return ['strong'];
  }
};
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

/**
 * text
 */

var doc = {
  content: 'block+'
};
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

var blockquote = {
  content: 'block+',
  group: 'block',
  defining: true,
  parseDOM: [{
    tag: 'blockquote'
  }],
  toDOM: function toDOM() {
    return ['blockquote', 0];
  }
};
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

/**
 * bullet_list
 */

var bullet_list = {
  content: 'list_item+',
  group: 'block',
  attrs: {
    tight: {
      "default": false
    }
  },
  parseDOM: [{
    tag: 'ul',
    getAttrs: function getAttrs(dom) {
      return {
        tight: dom.hasAttribute('data-tight')
      };
    }
  }],
  toDOM: function toDOM(node) {
    return ['ul', {
      'data-tight': node.attrs.tight ? 'true' : null
    }, 0];
  }
};
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

/**
 * code_block
 */

var code_block = {
  content: 'text*',
  attrs: {
    params: {
      "default": ''
    }
  },
  group: 'block',
  code: true,
  defining: true,
  parseDOM: [{
    tag: 'pre',
    preserveWhitespace: 'full'
  }],
  toDOM: function toDOM() {
    return ['pre', ['code', 0]];
  }
};
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

/**
 * hard_break
 */

var hard_break = {
  inline: true,
  group: 'inline',
  selectable: false,
  parseDOM: [{
    tag: 'br'
  }],
  toDOM: function toDOM() {
    return ['br'];
  }
};
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

function domAttrs(attrs) {
  var domAttrs = {};

  for (var key in attrs) {
    if (attrs[key]) {
      domAttrs["forestry-" + key] = attrs[key];
    }
  }

  return domAttrs;
}

function docAttrs(attrs) {
  var domAttrs = {};

  for (var key in attrs) {
    if (attrs[key]) {
      domAttrs[key] = attrs[key];
    }
  }

  return domAttrs;
}

function getAttrsWith(attrs) {
  return function (dom) {
    return _extends({}, attrs, {}, getAttrs(dom));
  };
}

function getAttrs(dom) {
  var attrs = {};
  var attributes = dom.attributes;

  for (var i = 0; i < attributes.length; i++) {
    var attribute = attributes[i];

    if (attribute.value) {
      var name = attribute.name.startsWith('forestry-') ? attribute.name.slice(9) : attribute.name;
      attrs[name] = attribute.value;
    }
  }

  return attrs;
}
/**
 * heading
 */


var heading = {
  attrs: {
    level: {
      "default": 1
    },
    "class": {
      "default": ''
    },
    id: {
      "default": ''
    }
  },
  content: 'inline*',
  marks: '_',
  group: 'block',
  defining: true,
  parseDOM: [{
    tag: 'h1',
    getAttrs: /*#__PURE__*/getAttrsWith({
      level: 1
    })
  }, {
    tag: 'h2',
    getAttrs: /*#__PURE__*/getAttrsWith({
      level: 2
    })
  }, {
    tag: 'h3',
    getAttrs: /*#__PURE__*/getAttrsWith({
      level: 3
    })
  }, {
    tag: 'h4',
    getAttrs: /*#__PURE__*/getAttrsWith({
      level: 4
    })
  }, {
    tag: 'h5',
    getAttrs: /*#__PURE__*/getAttrsWith({
      level: 5
    })
  }, {
    tag: 'h6',
    getAttrs: /*#__PURE__*/getAttrsWith({
      level: 6
    })
  }],
  toDocument: function toDocument(node) {
    var _node$attrs = node.attrs,
        level = _node$attrs.level,
        other = _objectWithoutPropertiesLoose(_node$attrs, ["level"]);

    return ['h' + level, docAttrs(other), 0];
  },
  toDOM: function toDOM(node) {
    var _node$attrs2 = node.attrs,
        level = _node$attrs2.level,
        other = _objectWithoutPropertiesLoose(_node$attrs2, ["level"]);

    return ['h' + level, domAttrs(other), 0];
  }
};
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

/**
 * horizontal_rule
 */

var horizontal_rule = {
  group: 'block',
  allowGapCursor: true,
  parseDOM: [{
    tag: 'hr'
  }],
  toDOM: function toDOM() {
    return ['hr'];
  }
};
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

var image = {
  inline: true,
  attrs: {
    src: {},
    align: {
      "default": null
    },
    alt: {
      "default": null
    },
    title: {
      "default": null
    },
    width: {
      "default": null
    },
    height: {
      "default": null
    }
  },
  group: 'inline',
  draggable: true,
  allowGapCursor: true,
  parseDOM: [{
    tag: 'img[src]',
    getAttrs: function getAttrs(dom) {
      return {
        src: dom.getAttribute('src'),
        title: dom.getAttribute('title'),
        alt: dom.getAttribute('alt'),
        align: getAlignFromDOM(dom),
        width: dom.getAttribute('width'),
        height: dom.getAttribute('height')
      };
    }
  }],
  toDOM: function toDOM(node) {
    var attrs = {
      src: node.attrs.src
    };
    if (node.attrs.title) attrs.title = node.attrs.title;
    if (node.attrs.alt) attrs.alt = node.attrs.alt;
    if (node.attrs.width) attrs.width = node.attrs.width;
    if (node.attrs.height) attrs.height = node.attrs.height;
    if (node.attrs.align) attrs['class'] = "align-" + node.attrs.align;
    return ['img', attrs];
  }
};
var alignRegex = /align-([a-z]*)/;

function getAlignFromDOM(image) {
  var className = image.getAttribute('class') || '';
  var match = alignRegex.exec(className);

  if (match && match.length > 1) {
    return match[1];
  }

  return null;
}
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

/**
 * list_item
 */


var list_item = {
  content: 'paragraph block*',
  defining: true,
  parseDOM: [{
    tag: 'li'
  }],
  toDOM: function toDOM() {
    return ['li', 0];
  }
};
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

/**
 * Ordered List
 */

var ordered_list = {
  content: 'list_item+',
  group: 'block',
  attrs: {
    order: {
      "default": 1
    },
    tight: {
      "default": false
    }
  },
  parseDOM: [{
    tag: 'ol',
    getAttrs: function getAttrs(dom) {
      return {
        order: dom.hasAttribute('start') ? +(dom.getAttribute('start') || 0) : 1,
        tight: dom.hasAttribute('data-tight')
      };
    }
  }],
  toDOM: function toDOM(node) {
    return ['ol', {
      start: node.attrs.order == 1 ? null : node.attrs.order,
      'data-tight': node.attrs.tight ? 'true' : null
    }, 0];
  }
};
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

var paragraph = {
  content: 'inline*',
  marks: '_',
  attrs: {
    "class": {
      "default": ''
    },
    id: {
      "default": ''
    }
  },
  group: 'block',
  parseDOM: [{
    tag: 'p',
    getAttrs: getAttrs
  }],
  toDocument: function toDocument(node) {
    return ['p', docAttrs(node.attrs), 0];
  },
  toDOM: function toDOM(node) {
    return ['p', domAttrs(node.attrs), 0];
  }
};
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

/**
 * text
 */

var text = {
  group: 'inline'
};
var tables = /*#__PURE__*/tableNodes({
  tableGroup: 'block',
  cellContent: 'inline*',
  cellAttributes: {}
});
tables.table_cell = /*#__PURE__*/_extends({}, tables.table_cell, {
  marks: '_',
  attrs: /*#__PURE__*/_extends({}, tables.table_cell.attrs, {
    align: {
      "default": null
    }
  }),
  toDOM: function toDOM(node) {
    var attrs = {};

    if (node.attrs.align) {
      attrs.style = "text-align: " + node.attrs.align + ";";
    }

    return ['td', attrs, 0];
  }
});
tables.table_header = /*#__PURE__*/_extends({}, tables.table_header, {
  marks: '_',
  attrs: /*#__PURE__*/_extends({}, tables.table_header.attrs, {
    align: {
      "default": null
    }
  }),
  toDOM: function toDOM(node) {
    var attrs = {};

    if (node.attrs.align) {
      attrs.style = "text-align: " + node.attrs.align + ";";
    }

    return ['th', attrs, 0];
  }
});
var marks = {
  code: code,
  em: em,
  link: link,
  strike: strike,
  strong: strong
};

var nodes = /*#__PURE__*/_extends({
  doc: doc,
  paragraph: paragraph,
  blockquote: blockquote,
  bullet_list: bullet_list,
  code_block: code_block,
  hard_break: hard_break,
  heading: heading,
  horizontal_rule: horizontal_rule,
  image: image,
  list_item: list_item,
  ordered_list: ordered_list,
  text: text
}, tables);

var buildSchema = function buildSchema() {
  return new Schema({
    nodes: nodes,
    marks: marks
  });
};
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/


var TranslatorClass = function TranslatorClass() {};
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/


var MarkdownSerializer = /*#__PURE__*/function () {
  function MarkdownSerializer(nodes, marks) {
    // :: Object<(MarkdownSerializerState, Node)> The node serializer
    // functions for this serializer.
    this.nodes = nodes; // :: Object The mark serializer info.

    this.marks = marks;
  } // :: (Node, ?Object) → string
  // Serialize the content of the given node to
  // [CommonMark](http://commonmark.org/).


  var _proto = MarkdownSerializer.prototype;

  _proto.serialize = function serialize(content, options) {
    if (options === void 0) {
      options = {};
    }

    var state = new MarkdownSerializerState(this.nodes, this.marks, options);
    state.renderContent(content);
    return state.out;
  };

  return MarkdownSerializer;
}(); // ::- This is an object used to track state and expose
// methods related to markdown serialization. Instances are passed to
// node and mark serialization methods (see `toMarkdown`).


var MarkdownSerializerState = /*#__PURE__*/function () {
  function MarkdownSerializerState(nodes, marks, options) {
    this.nodes = nodes;
    this.marks = marks;
    this.delim = this.out = '';
    this.closed = false;
    this.inTightList = false; // :: Object
    // The options passed to the serializer.
    //   tightLists:: ?bool
    //   Whether to render lists in a tight style. This can be overridden
    //   on a node level by specifying a tight attribute on the node.
    //   Defaults to false.

    this.options = options || {};
    if (typeof this.options.tightLists == 'undefined') this.options.tightLists = false;
  }

  var _proto2 = MarkdownSerializerState.prototype;

  _proto2.flushClose = function flushClose(size) {
    if (this.closed) {
      if (!this.atBlank()) this.out += '\n';
      if (size == null) size = 2;

      if (size > 1) {
        var delimMin = this.delim;
        var trim = /\s+$/.exec(delimMin);
        if (trim) delimMin = delimMin.slice(0, delimMin.length - trim[0].length);

        for (var i = 1; i < size; i++) {
          this.out += delimMin + '\n';
        }
      }

      this.closed = false;
    }
  } // :: (string, ?string, Node, ())
  // Render a block, prefixing each line with `delim`, and the first
  // line in `firstDelim`. `node` should be the node that is closed at
  // the end of the block, and `f` is a function that renders the
  // content of the block.
  ;

  _proto2.wrapBlock = function wrapBlock(delim, firstDelim, node, f) {
    var old = this.delim;
    this.write(firstDelim || delim);
    this.delim += delim;
    f();
    this.delim = old;
    this.closeBlock(node);
  };

  _proto2.atBlank = function atBlank() {
    return /(^|\n)$/.test(this.out);
  } // :: ()
  // Ensure the current content ends with a newline.
  ;

  _proto2.ensureNewLine = function ensureNewLine() {
    if (!this.atBlank()) this.out += '\n';
  } // :: (?string)
  // Prepare the state for writing output (closing closed paragraphs,
  // adding delimiters, and so on), and then optionally add content
  // (unescaped) to the output.
  ;

  _proto2.write = function write(content) {
    this.flushClose();
    if (this.delim && this.atBlank()) this.out += this.delim;
    if (content) this.out += content;
  } // :: (Node)
  // Close the block for the given node.
  ;

  _proto2.closeBlock = function closeBlock(node) {
    this.closed = node;
  } // :: (string, ?bool)
  // Add the given text to the document. When escape is not `false`,
  // it will be escaped.
  ;

  _proto2.text = function text(_text, escape, escFn) {
    var lines = _text.split('\n');

    for (var i = 0; i < lines.length; i++) {
      var startOfLine = this.atBlank() || this.closed;
      this.write();
      var escapedString = escape !== false ? this.esc(lines[i], startOfLine) : lines[i];
      escapedString = escFn ? escFn(escapedString) : escapedString;
      this.out += escapedString;
      if (i != lines.length - 1) this.out += '\n';
    }
  } // :: (Node)
  // Render the given node as a block.
  ;

  _proto2.render = function render(node, parent, index, escFn) {
    if (typeof parent == 'number') throw new Error('!');
    this.nodes[node.type.name](this, node, parent, index, escFn);
  } // :: (Node)
  // Render the contents of `parent` as block nodes.
  ;

  _proto2.renderContent = function renderContent(parent) {
    var _this = this;

    parent.forEach(function (node, _, i) {
      return _this.render(node, parent, i);
    });
  } // :: (Node)
  // Render the contents of `parent` as inline content.
  ;

  _proto2.renderInline = function renderInline(parent, escFn) {
    var _this2 = this;

    var active = [];
    var trailing = '';

    var progress = function progress(node, _, index) {
      if (index === void 0) {
        index = 0;
      }

      var marks = node ? node.marks : [];
      var indexOfCode = marks.findIndex(function (p) {
        return p.type.name === 'code';
      });

      if (indexOfCode >= 0 && marks.length > 1) {
        marks = [].concat(marks.slice(0, indexOfCode), marks.slice(indexOfCode + 1, marks.length), [marks[indexOfCode]]);
      }

      var leading = trailing;
      trailing = ''; // If whitespace has to be expelled from the node, adjust
      // leading and trailing accordingly.

      if (node && node.isText && marks.some(function (mark, _i, _a) {
        var info = _this2.marks[mark.type.name];
        return !!(info && info.expelEnclosingWhitespace);
      }) && /^(\s*)(.*?)(\s*)$/.test(node.text || '') // Todo: Don't duplicate this check.
      ) {
          var _Array$from = Array.from(/^(\s*)(.*?)(\s*)$/.exec(node.text || '') || []),
              lead = _Array$from[1],
              _inner = _Array$from[2],
              trail = _Array$from[3];

          leading += lead;
          trailing = trail;

          if (lead || trail) {
            node = _inner ? node.withText(_inner) : null;
            if (!node) marks = active;
          }
        }

      var inner = marks.length && marks[marks.length - 1];
      var noEsc = inner && _this2.marks[inner.type.name].escape === false;
      var len = marks.length - (noEsc ? 1 : 0); // Try to reorder 'mixable' marks, such as em and strong, which
      // in Markdown may be opened and closed in different order, so
      // that order of the marks for the token matches the order in
      // active.

      outer: for (var i = 0; i < len; i++) {
        var mark = marks[i];
        if (!_this2.marks[mark.type.name].mixable) break;

        for (var j = 0; j < active.length; j++) {
          var other = active[j];
          if (!_this2.marks[other.type.name].mixable) break;

          if (mark.eq(other)) {
            if (i > j) marks = marks.slice(0, j).concat(mark).concat(marks.slice(j, i)).concat(marks.slice(i + 1, len));else if (j > i) marks = marks.slice(0, i).concat(marks.slice(i + 1, j)).concat(mark).concat(marks.slice(j, len));
            continue outer;
          }
        }
      } // Find the prefix of the mark set that didn't change


      var keep = 0;

      while (keep < Math.min(active.length, len) && marks[keep].eq(active[keep])) {
        ++keep;
      } // Close the marks that need to be closed


      while (keep < active.length) {
        _this2.text(_this2.markString(active.pop(), false, node), false);
      } // Output any previously expelled trailing whitespace outside the marks


      if (leading) _this2.text(leading); // Open the marks that need to be opened

      if (node) {
        while (active.length < len) {
          var add = marks[active.length];
          active.push(add);

          _this2.text(_this2.markString(add, true, node), false);
        } // Render the node. Special case code marks, since their content
        // may not be escaped.


        if (noEsc && node.isText && inner) _this2.text(_this2.markString(inner, false, node) + node.text + _this2.markString(inner, true, node), false, escFn);else _this2.render(node, parent, index, escFn);
      }
    };

    parent.forEach(progress);
    progress(null);
  } // :: (Node, string, (number) → string)
  // Render a node's content as a list. `delim` should be the extra
  // indentation added to all lines except the first in an item,
  // `firstDelim` is a function going from an item index to a
  // delimiter for the first line of the item.
  ;

  _proto2.renderList = function renderList(node, delim, firstDelim) {
    var _this3 = this;

    if (this.closed && this.closed.type == node.type) this.flushClose(3);else if (this.inTightList) this.flushClose(1);
    var isTight = this.options.tightLists;
    var prevTight = this.inTightList;
    this.inTightList = !!isTight;
    node.forEach(function (child, _, i) {
      if (i && isTight) _this3.flushClose(1);

      _this3.wrapBlock(delim, firstDelim(i), node, function () {
        return _this3.render(child, node, i);
      });
    });
    this.inTightList = prevTight;
  } // :: (string, ?bool) → string
  // Escape the given string so that it can safely appear in Markdown
  // content. If `startOfLine` is true, also escape characters that
  // has special meaning only at the start of the line.
  ;

  _proto2.esc = function esc(str, startOfLine) {
    str = str.replace(/[`\\~\[\]]/g, '\\$&');
    if (startOfLine) str = str.replace(/^[#\-*+]/, '\\$&').replace(/^(\d+)\./, '$1\\.');
    return str;
  };

  _proto2.quote = function quote(str) {
    var wrap = str.indexOf('"') == -1 ? '""' : str.indexOf("'") == -1 ? "''" : '()';
    return wrap[0] + str + wrap[1];
  } // :: (string, number) → string
  // Repeat the given string `n` times.
  ;

  _proto2.repeat = function repeat(str, n) {
    var out = '';

    for (var i = 0; i < n; i++) {
      out += str;
    }

    return out;
  } // : (Mark, bool) → string
  // Get the markdown string for a given opening or closing mark.
  ;

  _proto2.markString = function markString(mark, open, node) {
    var info = this.marks[mark.type.name];
    var value = open ? info.open : info.close;
    return typeof value == 'string' ? value : value(this, mark, node);
  } // :: (string) → { leading: ?string, trailing: ?string }
  // Get leading and trailing whitespace from a string. Values of
  // leading or trailing property of the return object will be undefined
  // if there is no match.
  ;

  _proto2.getEnclosingWhitespace = function getEnclosingWhitespace(text) {
    return {
      leading: (text.match(/^(\s+)/) || [])[0],
      trailing: (text.match(/(\s+)$/) || [])[0]
    };
  };

  return MarkdownSerializerState;
}();

var _ALIGN_STYLES;
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/


var get = /*#__PURE__*/require('lodash.get');

var ALIGN_STYLES = (_ALIGN_STYLES = {}, _ALIGN_STYLES['text-align:left'] = 'left', _ALIGN_STYLES['text-align:center'] = 'center', _ALIGN_STYLES['text-align:right'] = 'right', _ALIGN_STYLES);
var ALIGN_DASHES = {
  left: ':---',
  center: ':---:',
  right: '---:'
};
var TOKENS = {
  blockquote: {
    block: 'blockquote'
  },
  paragraph: {
    block: 'paragraph'
  },
  list_item: {
    block: 'list_item'
  },
  bullet_list: {
    block: 'bullet_list'
  },
  ordered_list: {
    block: 'ordered_list',
    getAttrs: function getAttrs(tok) {
      return {
        order: +tok.attrGet('order') || 1
      };
    }
  },
  heading: {
    block: 'heading',
    getAttrs: function getAttrs(tok) {
      return {
        level: +tok.tag.slice(1)
      };
    }
  },
  code_block: {
    block: 'code_block'
  },
  fence: {
    block: 'code_block',
    getAttrs: function getAttrs(tok) {
      return {
        params: tok.info || ''
      };
    }
  },
  hr: {
    node: 'horizontal_rule'
  },
  image: {
    node: 'image',
    getAttrs: function getAttrs(tok) {
      return {
        src: tok.attrGet('src'),
        title: tok.attrGet('title') || null,
        alt: tok.children[0] && tok.children[0].content || null,
        width: tok.attrGet('width') || null,
        height: tok.attrGet('height') || null
      };
    }
  },
  table: {
    block: 'table'
  },
  table_row: {
    block: 'table_row'
  },
  table_cell: {
    block: 'table_cell',
    getAttrs: function getAttrs(tok) {
      var style = '';

      if (tok.attrs) {
        for (var i = 0; i < tok.attrs.length; i++) {
          if (tok.attrs[i][0] === 'style') {
            style = tok.attrs[i][1];
          }
        }
      }

      return {
        align: ALIGN_STYLES[style]
      };
    }
  },
  table_header: {
    block: 'table_header',
    getAttrs: function getAttrs(tok) {
      var style = '';

      if (tok.attrs) {
        for (var i = 0; i < tok.attrs.length; i++) {
          if (tok.attrs[i][0] === 'style') {
            style = tok.attrs[i][1];
          }
        }
      }

      return {
        align: ALIGN_STYLES[style]
      };
    }
  },
  hardbreak: {
    node: 'hard_break'
  },
  em: {
    mark: 'em'
  },
  strike: {
    mark: 'strike'
  },
  strong: {
    mark: 'strong'
  },
  link: {
    mark: 'link',
    getAttrs: function getAttrs(tok) {
      return {
        href: tok.attrGet('href'),
        title: tok.attrGet('title') || null
      };
    }
  },
  code_inline: {
    mark: 'code'
  }
};
var NODES = {
  blockquote: function blockquote(state, node) {
    state.wrapBlock('> ', null, node, function () {
      return state.renderContent(node);
    });
  },
  code_block: function code_block(state, node) {
    if (!node.attrs.params) {
      state.wrapBlock('    ', null, node, function () {
        return state.text(node.textContent, false);
      });
    } else {
      state.write('```' + node.attrs.params + '\n');
      state.text(node.textContent, false);
      state.ensureNewLine();
      state.write('```');
      state.closeBlock(node);
    }
  },
  heading: function heading(state, node) {
    if (/\n/.test(node.textContent) && node.attrs.level < 3) {
      state.renderInline(node);
      state.write('\n');
      state.write(node.attrs.level === 1 ? '=' : '-');
    } else {
      state.write(state.repeat('#', node.attrs.level) + ' ');
      state.renderInline(node);
    }

    state.closeBlock(node);
  },
  horizontal_rule: function horizontal_rule(state, node) {
    state.write(node.attrs.markup || '***');
    state.closeBlock(node);
  },
  bullet_list: function bullet_list(state, node) {
    state.renderList(node, '  ', function () {
      return (node.attrs.bullet || '*') + ' ';
    });
  },
  ordered_list: function ordered_list(state, node) {
    var start = node.attrs.order || 1;
    var maxW = String(start + node.childCount - 1).length;
    var space = state.repeat(' ', maxW + 2);
    state.renderList(node, space, function (i) {
      var nStr = String(start + i);
      return state.repeat(' ', maxW - nStr.length) + nStr + '. ';
    });
  },
  list_item: function list_item(state, node) {
    state.renderContent(node);
  },
  paragraph: function paragraph(state, node, _parent, _index) {
    state.renderInline(node);
    state.closeBlock(node);
  },
  image: function image(state, node) {
    var size = '';

    if (node.attrs.height || node.attrs.width) {
      size = " =" + (node.attrs.width || '') + "x" + (node.attrs.height || '');
    }

    var alt = state.esc(node.attrs.alt || '');
    var src = state.esc(node.attrs.src);
    var title = node.attrs.title ? ' ' + state.quote(node.attrs.title) : '';
    state.write("![" + alt + "](" + src + title + size + ")");
  },
  hard_break: function hard_break(state, node, parent, index) {
    if (!parent || typeof index !== 'number') return;

    for (var i = index + 1; i < parent.childCount; i++) {
      if (parent.child(i).type != node.type) {
        state.write('  \n');
        return;
      }
    }
  },
  text: function text(state, node, _1, _2, escFn) {
    if (typeof node.text !== 'string') return;
    state.text(node.text, true, escFn);
  },
  table: function table(state, node) {
    var inHead = true;
    node.forEach(function (row) {
      var nextRowIsInBody = row.content.child(0).type.name === 'table_cell';

      if (inHead && nextRowIsInBody) {
        state.write('|');

        for (var i = 0; i < row.childCount; i++) {
          var align = row.content.child(i).attrs.align;
          var dash = ALIGN_DASHES[align] || '---';
          state.write(" " + dash + " |");
        }

        state.write('\n');
        inHead = false;
      }

      NODES.table_row(state, row);
    });
    state.closeBlock(node);
  },
  table_row: function table_row(state, node) {
    state.write('|');
    state.renderContent(node);
    state.write('\n');
  },
  table_cell: function table_cell(state, node) {
    state.write(' ');
    /**
     * In the case of table's are pipes escaped.
     */

    state.renderInline(node, function (str) {
      return str.replace(/[\|]/g, '\\$&');
    });
    state.write(' |');
  },
  table_header: function table_header(state, node) {
    NODES.table_cell(state, node);
  }
};
var MARKS = {
  em: {
    open: '_',
    close: '_',
    mixable: true,
    expelEnclosingWhitespace: true
  },
  strong: {
    open: function open(_state, mark, node) {
      if (get(node, 'text', '').endsWith('*')) return mark.openedWith = '__';
      return '**';
    },
    close: function close(_state, mark, node) {
      if (mark.openedWith) {
        var closeWith = mark.openedWith;
        mark.openedWith = null;
        return closeWith;
      }

      if (get(node, 'text', '').endsWith('*')) return '__';
      return '**';
    },
    mixable: true,
    expelEnclosingWhitespace: true
  },
  link: {
    open: '[',
    close: function close(state, mark) {
      return '](' + state.esc(mark.attrs.href) + (mark.attrs.title ? ' ' + state.quote(mark.attrs.title) : '') + ')';
    }
  },
  strike: {
    open: '~~',
    close: '~~',
    mixable: true,
    expelEnclosingWhitespace: true
  },
  code: {
    open: '`',
    close: '`',
    escape: false
  }
};

function buildTokensForSchema(schema) {
  var tokens = {};
  if (schema.nodes.blockquote) tokens.blockquote = TOKENS.blockquote;
  if (schema.nodes.paragraph) tokens.paragraph = TOKENS.paragraph;
  if (schema.nodes.list_item) tokens.list_item = TOKENS.list_item;
  if (schema.nodes.bullet_list) tokens.bullet_list = TOKENS.bullet_list;
  if (schema.nodes.ordered_list) tokens.ordered_list = TOKENS.ordered_list;
  if (schema.nodes.heading) tokens.heading = TOKENS.heading;

  if (schema.nodes.code_block) {
    tokens.code_block = TOKENS.code_block;
    tokens.fence = TOKENS.fence;
  }

  if (schema.nodes.horizontal_rule) tokens.hr = TOKENS.hr;
  if (schema.nodes.image) tokens.image = TOKENS.image;
  if (schema.nodes.hard_break) tokens.hardbreak = TOKENS.hardbreak;
  if (schema.nodes.ordered_list) tokens.ordered_list = TOKENS.ordered_list;
  if (schema.nodes.bullet_list) tokens.bullet_list = TOKENS.bullet_list;
  if (schema.nodes.list_item) tokens.list_item = TOKENS.list_item;

  if (schema.nodes.table) {
    tokens.table = TOKENS.table;
    tokens.thead = {
      ignore: true
    };
    tokens.th = TOKENS.table_header;
    tokens.tbody = {
      ignore: true
    };
    tokens.tr = TOKENS.table_row;
    tokens.td = TOKENS.table_cell;
  }

  if (schema.marks.em) tokens.em = TOKENS.em;
  if (schema.marks.strong) tokens.strong = TOKENS.strong;
  if (schema.marks.link) tokens.link = TOKENS.link;
  if (schema.marks.code) tokens.code_inline = TOKENS.code_inline;
  if (schema.marks.strike) tokens.strike = TOKENS.strike;
  return tokens;
}

function buildNodesFromSchema(schema) {
  var nodes = {};
  if (schema.nodes.blockquote) nodes.blockquote = NODES.blockquote;
  if (schema.nodes.paragraph) nodes.paragraph = NODES.paragraph;
  if (schema.nodes.list_item) nodes.list_item = NODES.list_item;
  if (schema.nodes.bullet_list) nodes.bullet_list = NODES.bullet_list;
  if (schema.nodes.ordered_list) nodes.ordered_list = NODES.ordered_list;
  if (schema.nodes.heading) nodes.heading = NODES.heading;
  if (schema.nodes.code_block) nodes.code_block = NODES.code_block;
  if (schema.nodes.horizontal_rule) nodes.horizontal_rule = NODES.horizontal_rule;
  if (schema.nodes.image) nodes.image = NODES.image;
  if (schema.nodes.hard_break) nodes.hard_break = NODES.hard_break;
  if (schema.nodes.ordered_list) nodes.ordered_list = NODES.ordered_list;
  if (schema.nodes.bullet_list) nodes.bullet_list = NODES.bullet_list;
  if (schema.nodes.list_item) nodes.list_item = NODES.list_item;

  if (schema.nodes.table) {
    nodes.table = NODES.table;
    nodes.table_header = NODES.table_header;
    nodes.table_row = NODES.table_row;
    nodes.table_cell = NODES.table_cell;
  }

  nodes.text = NODES.text;
  return nodes;
}

function buildMarksFromSchema(schema) {
  return MARKS;
}
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/


function CommonMarkSerializer(schema) {
  return new MarkdownSerializer(buildNodesFromSchema(schema), buildMarksFromSchema());
}
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/


function parseNextNumber(str, pos, max) {
  var code;
  var start = pos;
  var result = {
    ok: false,
    pos: pos
  };
  code = str.charCodeAt(pos);

  while (pos < max && code >= 0x30
  /* 0 */
  && code <= 0x39 ||
  /* 9 */
  code === 0x25
  /* % */
  ) {
    code = str.charCodeAt(++pos);
  }

  result.ok = true;
  result.pos = pos;
  result.value = Number(str.slice(start, pos));
  return result;
}

function parseImageSize(str, pos, max) {
  var code;
  var result = {
    ok: false,
    pos: 0
  };

  if (pos >= max) {
    return result;
  }

  code = str.charCodeAt(pos);

  if (code !== 0x3d
  /* = */
  ) {
      return result;
    }

  pos++; // size must follow = without any white spaces as follows
  // (1) =300x200
  // (2) =300x
  // (3) =x200

  code = str.charCodeAt(pos);

  if (code !== 0x78
  /* x */
  && (code < 0x30 || code > 0x39)
  /* [0-9] */
  ) {
      return result;
    } // parse width


  var resultW = parseNextNumber(str, pos, max);
  pos = resultW.pos; // next charactor must be 'x'

  code = str.charCodeAt(pos);

  if (code !== 0x78
  /* x */
  ) {
      return result;
    }

  pos++; // parse height

  var resultH = parseNextNumber(str, pos, max);
  pos = resultH.pos;
  result.width = resultW.value;
  result.height = resultH.value;
  result.pos = pos;
  result.ok = true;
  return result;
}
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/


function parseLinkDestination(md, state, pos) {
  var isSpace = md.utils.isSpace;
  var unescapeAll = md.utils.unescapeAll;
  var str = state.src;
  var max = state.posMax;
  var code;
  var level;
  var lines = 0;
  var start = pos;
  var result = {
    ok: false,
    pos: 0,
    lines: 0,
    str: ''
  };

  if (str.charCodeAt(pos) === 0x3c
  /* < */
  ) {
      pos++;

      while (pos < max) {
        code = str.charCodeAt(pos);

        if (code === 0x0a
        /* \n */
        || isSpace(code)) {
          return result;
        }

        if (code === 0x3e
        /* > */
        ) {
            result.pos = pos + 1;
            result.str = unescapeAll(str.slice(start + 1, pos));
            result.ok = true;
            return result;
          }

        if (code === 0x5c
        /* \ */
        && pos + 1 < max) {
          pos += 2;
          continue;
        }

        pos++;
      } // no closing '>'


      return result;
    } // this should be ... } else { ... branch


  level = 0;

  while (pos < max) {
    code = str.charCodeAt(pos);

    if (code == 61
    /* = */
    || code == 34
    /* " */
    || code == 39
    /* ' */
    // code === 0x20
    ) {
        pos--;
        break;
      } // ascii control characters


    if (code < 0x20 || code === 0x7f) {
      break;
    }

    if (code === 0x5c
    /* \ */
    && pos + 1 < max) {
      pos += 2;
      continue;
    }

    if (code === 0x28
    /* ( */
    ) {
        level++;
      }

    if (code === 0x29
    /* ) */
    ) {
        if (level === 0) {
          break;
        }

        level--;
      }

    pos++;
  }

  if (start === pos) {
    return result;
  }

  if (level !== 0) {
    return result;
  }

  result.str = unescapeAll(str.slice(start, pos));
  result.lines = lines;
  result.pos = pos;
  result.ok = true;
  return result;
}
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/


function image_with_size(md) {
  return function (state, silent) {
    var attrs,
        code,
        label,
        pos,
        ref,
        res,
        title,
        width = null,
        height = null,
        token,
        tokens,
        start,
        href = '';
    var oldPos = state.pos,
        max = state.posMax;

    if (state.src.charCodeAt(state.pos) !== 0x21
    /* ! */
    ) {
        return false;
      }

    if (state.src.charCodeAt(state.pos + 1) !== 0x5b
    /* [ */
    ) {
        return false;
      }

    var labelStart = state.pos + 2;
    var labelEnd = md.helpers.parseLinkLabel(state, state.pos + 1, false); // parser failed to find ']', so it's not a valid link

    if (labelEnd < 0) {
      return false;
    }

    pos = labelEnd + 1;

    if (pos < max && state.src.charCodeAt(pos) === 0x28
    /* ( */
    ) {
        //
        // Inline link
        //
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;

        for (; pos < max; pos++) {
          code = state.src.charCodeAt(pos);

          if (code !== 0x20 && code !== 0x0a) {
            break;
          }
        }

        if (pos >= max) {
          return false;
        } // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination


        start = pos;
        res = parseLinkDestination(md, state, pos);

        if (res.ok) {
          href = res.str;

          if (state.md.validateLink(href)) {
            pos = res.pos;
          } else {
            href = '';
          }
        } // [link](  <href>  "title"  )
        //                ^^ skipping these spaces


        start = pos;

        for (; pos < max; pos++) {
          code = state.src.charCodeAt(pos);

          if (code !== 0x20 && code !== 0x0a) {
            break;
          }
        } // [link](  <href>  "title"  )
        //                  ^^^^^^^ parsing link title


        res = md.helpers.parseLinkTitle(state.src, pos, state.posMax);

        if (pos < max && start !== pos && res.ok) {
          title = res.str;
          pos = res.pos; // [link](  <href>  "title"  )
          //                         ^^ skipping these spaces

          for (; pos < max; pos++) {
            code = state.src.charCodeAt(pos);

            if (code !== 0x20 && code !== 0x0a) {
              break;
            }
          }
        } else {
          title = '';
        } // [link](  <href>  "title" =WxH  )
        //                          ^^^^ parsing image size


        if (pos - 1 >= 0) {
          code = state.src.charCodeAt(pos - 1); // there must be at least one white spaces
          // between previous field and the size

          if (code === 0x20) {
            res = parseImageSize(state.src, pos, state.posMax);

            if (res.ok) {
              width = res.width;
              height = res.height;
              pos = res.pos; // [link](  <href>  "title" =WxH  )
              //                              ^^ skipping these spaces

              for (; pos < max; pos++) {
                code = state.src.charCodeAt(pos);

                if (code !== 0x20 && code !== 0x0a) {
                  break;
                }
              }
            }
          }
        }

        if (pos >= max || state.src.charCodeAt(pos) !== 0x29
        /* ) */
        ) {
            state.pos = oldPos;
            return false;
          }

        pos++;
      } else {
      //
      // Link reference
      //
      if (typeof state.env.references === 'undefined') {
        return false;
      } // [foo]  [bar]
      //      ^^ optional whitespace (can include newlines)


      for (; pos < max; pos++) {
        code = state.src.charCodeAt(pos);

        if (code !== 0x20 && code !== 0x0a) {
          break;
        }
      }

      if (pos < max && state.src.charCodeAt(pos) === 0x5b
      /* [ */
      ) {
          start = pos + 1;
          pos = md.helpers.parseLinkLabel(state, pos);

          if (pos >= 0) {
            label = state.src.slice(start, pos++);
          } else {
            pos = labelEnd + 1;
          }
        } else {
        pos = labelEnd + 1;
      } // covers label === '' and label === undefined
      // (collapsed reference link and shortcut reference link respectively)


      if (!label) {
        label = state.src.slice(labelStart, labelEnd);
      }

      ref = state.env.references[md.utils.normalizeReference(label)];

      if (!ref) {
        state.pos = oldPos;
        return false;
      }

      href = ref.href;
      title = ref.title;
    } //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //


    if (!silent) {
      state.pos = labelStart;
      state.posMax = labelEnd;
      var newState = new state.md.inline.State(state.src.slice(labelStart, labelEnd), state.md, state.env, tokens = []);
      newState.md.inline.tokenize(newState);
      token = state.push('image', 'img', 0);
      token.attrs = attrs = [['src', href], ['alt', '']];
      token.children = tokens;

      if (title) {
        attrs.push(['title', title]);
      }

      if (width !== null) {
        attrs.push(['width', width]);
      }

      if (height !== null) {
        attrs.push(['height', height]);
      }
    }

    state.pos = pos;
    state.posMax = max;
    return true;
  };
}

function imsize(md) {
  md.inline.ruler.before('emphasis', 'image', image_with_size(md));
}
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/


function _link(md) {
  return function (state, silent) {
    var normalizeReference = state.md.utils.normalizeReference;
    var isSpace = state.md.utils.isSpace;
    var attrs,
        code,
        label,
        pos,
        res,
        ref,
        title,
        token,
        href = '',
        start = state.pos,
        parseReference = true;
    var oldPos = state.pos,
        max = state.posMax;

    if (state.src.charCodeAt(state.pos) !== 0x5b
    /* [ */
    ) {
        return false;
      }

    var labelStart = state.pos + 1;
    var labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true); // parser failed to find ']', so it's not a valid link

    if (labelEnd < 0) {
      return false;
    }

    pos = labelEnd + 1;

    if (pos < max && state.src.charCodeAt(pos) === 0x28
    /* ( */
    ) {
        //
        // Inline link
        //
        // might have found a valid shortcut link, disable reference parsing
        parseReference = false; // [link](  <href>  "title"  )
        //        ^^ skipping these spaces

        pos++;

        for (; pos < max; pos++) {
          code = state.src.charCodeAt(pos);

          if (!isSpace(code) && code !== 0x0a) {
            break;
          }
        }

        if (pos >= max) {
          return false;
        }

        start = pos;
        res = parseLinkDestination(md, state, pos);

        if (res.ok) {
          href = res.str;

          if (state.md.validateLink(href)) {
            pos = res.pos;
          } else {
            href = '';
          }
        } // [link](  <href>  "title"  )
        //                ^^ skipping these spaces


        start = pos;

        for (; pos < max; pos++) {
          code = state.src.charCodeAt(pos);

          if (!isSpace(code) && code !== 0x0a) {
            break;
          }
        } // [link](  <href>  "title"  )
        //                  ^^^^^^^ parsing link title


        res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);

        if (pos < max && start !== pos && res.ok) {
          title = res.str;
          pos = res.pos; // [link](  <href>  "title"  )
          //                         ^^ skipping these spaces

          for (; pos < max; pos++) {
            code = state.src.charCodeAt(pos);

            if (!isSpace(code) && code !== 0x0a) {
              break;
            }
          }
        } else {
          title = '';
        }

        if (pos >= max || state.src.charCodeAt(pos) !== 0x29
        /* ) */
        ) {
            // parsing a valid shortcut link failed, fallback to reference
            parseReference = true;
          }

        pos++;
      }

    if (parseReference) {
      //
      // Link reference
      //
      if (typeof state.env.references === 'undefined') {
        return false;
      }

      if (pos < max && state.src.charCodeAt(pos) === 0x5b
      /* [ */
      ) {
          start = pos + 1;
          pos = state.md.helpers.parseLinkLabel(state, pos);

          if (pos >= 0) {
            label = state.src.slice(start, pos++);
          } else {
            pos = labelEnd + 1;
          }
        } else {
        pos = labelEnd + 1;
      } // covers label === '' and label === undefined
      // (collapsed reference link and shortcut reference link respectively)


      if (!label) {
        label = state.src.slice(labelStart, labelEnd);
      }

      ref = state.env.references[normalizeReference(label)];

      if (!ref) {
        state.pos = oldPos;
        return false;
      }

      href = ref.href;
      title = ref.title;
    } //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //


    if (!silent) {
      state.pos = labelStart;
      state.posMax = labelEnd;
      token = state.push('link_open', 'a', 1);
      token.attrs = attrs = [['href', href]];

      if (title) {
        attrs.push(['title', title]);
      }

      state.md.inline.tokenize(state);
      token = state.push('link_close', 'a', -1);
    }

    state.pos = pos;
    state.posMax = max;
    return true;
  };
}

function link$1(md) {
  md.inline.ruler.before('emphasis', 'link', _link(md));
}
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/


var MarkMapping = {
  strike: 's'
};

function maybeMerge(a, b) {
  if (a.isText && b.isText && Mark.sameSet(a.marks, b.marks)) return a.copy(a.text + b.text);
} // Object used to track the context of a running parse.


var MarkdownParseState = /*#__PURE__*/function () {
  function MarkdownParseState(schema, tokenHandlers) {
    this.schema = schema;
    this.stack = [{
      type: schema.topNodeType,
      content: []
    }];
    this.marks = Mark.none;
    this.tokenHandlers = tokenHandlers;
  }

  var _proto = MarkdownParseState.prototype;

  _proto.top = function top() {
    return this.stack[this.stack.length - 1];
  };

  _proto.push = function push(elt) {
    if (this.stack.length) this.top().content.push(elt);
  } // : (string)
  // Adds the given text to the current position in the document,
  // using the current marks as styling.
  ;

  _proto.addText = function addText(text) {
    if (!text) return;
    var nodes = this.top().content,
        last = nodes[nodes.length - 1],
        node = this.schema.text(text, this.marks);
    var merged;
    if (last && (merged = maybeMerge(last, node))) nodes[nodes.length - 1] = merged;else nodes.push(node);
  } // : (Mark)
  // Adds the given mark to the set of active marks.
  ;

  _proto.openMark = function openMark(mark) {
    this.marks = mark.addToSet(this.marks);
  } // : (Mark)
  // Removes the given mark from the set of active marks.
  ;

  _proto.closeMark = function closeMark(mark) {
    this.marks = mark.removeFromSet(this.marks);
  };

  _proto.parseTokens = function parseTokens(toks) {
    for (var i = 0; i < toks.length; i++) {
      var tok = toks[i];
      var handler = this.tokenHandlers[tok.type];
      if (!handler) throw new Error('Token type `' + tok.type + '` not supported by Markdown parser');
      handler(this, tok);
    }
  } // : (NodeType, ?Object, ?[Node]) → ?Node
  // Add a node at the current position.
  ;

  _proto.addNode = function addNode(type, attrs, content) {
    var node = type.createAndFill(attrs, content, this.marks);
    if (!node) return null;
    this.push(node);
    return node;
  } // : (NodeType, ?Object)
  // Wrap subsequent content in a node of the given type.
  ;

  _proto.openNode = function openNode(type, attrs) {
    this.stack.push({
      type: type,
      attrs: attrs,
      content: []
    });
  } // : () → ?Node
  // Close and return the node that is currently on top of the stack.
  ;

  _proto.closeNode = function closeNode() {
    if (this.marks.length) this.marks = Mark.none;
    var info = this.stack.pop();
    if (!info) return; //devWarn("Attempted to close a non-existent node.")

    return this.addNode(info.type, info.attrs, info.content);
  };

  return MarkdownParseState;
}();

function attrs(spec, token) {
  if (spec.getAttrs) return spec.getAttrs(token); // For backwards compatibility when `attrs` is a Function
  else if (spec.attrs instanceof Function) return spec.attrs(token);else return spec.attrs;
} // Code content is represented as a single token with a `content`
// property in Markdown-it.


function noOpenClose(type) {
  return type == 'code_inline' || type == 'code_block' || type == 'fence';
}

function withoutTrailingNewline(str) {
  return str[str.length - 1] == '\n' ? str.slice(0, str.length - 1) : str;
}

function noOp() {}

function tokenHandlers(schema, tokens) {
  var handlers = Object.create(null);

  var _loop = function _loop(type) {
    var spec = tokens[type];

    if (spec.block) {
      var nodeType = schema.nodeType(spec.block);

      if (noOpenClose(type)) {
        handlers[type] = function (state, tok) {
          state.openNode(nodeType, attrs(spec, tok));
          state.addText(withoutTrailingNewline(tok.content));
          state.closeNode();
        };
      } else {
        handlers[type + '_open'] = function (state, tok) {
          return state.openNode(nodeType, attrs(spec, tok));
        };

        handlers[type + '_close'] = function (state) {
          return state.closeNode();
        };
      }
    } else if (spec.node) {
      var _nodeType = schema.nodeType(spec.node);

      handlers[type] = function (state, tok) {
        return state.addNode(_nodeType, attrs(spec, tok));
      };
    } else if (spec.mark) {
      var markType = schema.marks[spec.mark];

      if (noOpenClose(type)) {
        handlers[type] = function (state, tok) {
          state.openMark(markType.create(attrs(spec, tok)));
          state.addText(withoutTrailingNewline(tok.content));
          state.closeMark(markType);
        };
      } else {
        handlers[(MarkMapping[type] || type) + '_open'] = function (state, tok) {
          return state.openMark(markType.create(attrs(spec, tok)));
        };

        handlers[(MarkMapping[type] || type) + '_close'] = function (state) {
          return state.closeMark(markType);
        };
      }
    } else if (spec.ignore) {
      if (noOpenClose(type)) {
        handlers[type] = noOp;
      } else {
        handlers[type + '_open'] = noOp;
        handlers[type + '_close'] = noOp;
      }
    } else {
      throw new RangeError('Unrecognized parsing spec ' + JSON.stringify(spec));
    }
  };

  for (var type in tokens) {
    _loop(type);
  }

  handlers.text = function (state, tok) {
    return state.addText(tok.content);
  };

  handlers.inline = function (state, tok) {
    return state.parseTokens(tok.children);
  };

  handlers.softbreak = function (state) {
    return state.addText('\n');
  };

  return handlers;
} // ::- A configuration of a Markdown parser. Such a parser uses
// [markdown-it](https://github.com/markdown-it/markdown-it) to
// tokenize a file, and then runs the custom rules it is given over
// the tokens to create a ProseMirror document tree.


var MarkdownParser = /*#__PURE__*/function () {
  //
  // **`getAttrs`**`: ?(MarkdownToken) → Object`
  //   : A function used to compute the attributes for the node or mark
  //     that takes a [markdown-it
  //     token](https://markdown-it.github.io/markdown-it/#Token) and
  //     returns an attribute object.
  //
  // **`ignore`**`: ?bool`
  //   : When true, ignore content for the matched token.
  function MarkdownParser(schema, tokenizer, tokens) {
    // :: Object The value of the `tokens` object used to construct
    // this parser. Can be useful to copy and modify to base other
    // parsers on.
    this.tokens = tokens;
    this.schema = schema;
    this.tokenizer = tokenizer;
    this.tokenHandlers = tokenHandlers(schema, tokens);
  } // :: (string) → Node
  // Parse a string as [CommonMark](http://commonmark.org/) markup,
  // and create a ProseMirror document as prescribed by this parser's
  // rules.


  var _proto2 = MarkdownParser.prototype;

  _proto2.parse = function parse(text) {
    var state = new MarkdownParseState(this.schema, this.tokenHandlers);
    var doc;
    state.parseTokens(this.tokenizer.parse(text, {}));

    do {
      doc = state.closeNode();
    } while (state.stack.length);

    return doc;
  };

  return MarkdownParser;
}();
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/


var markdownit = /*#__PURE__*/require('markdown-it');

function CommonMarkParser(schema) {
  var parser = markdownit({
    html: false
  });
  parser.use(imsize);
  parser.use(link$1);
  return new MarkdownParser(schema, parser, buildTokensForSchema(schema));
}

var MarkdownTranslator = /*#__PURE__*/function (_TranslatorClass) {
  _inheritsLoose(MarkdownTranslator, _TranslatorClass);

  function MarkdownTranslator(schema) {
    var _this;

    _this = _TranslatorClass.call(this) || this;
    _this.parser = null;
    _this.serializer = null;
    _this.schema = schema;
    return _this;
  }

  MarkdownTranslator.fromSchema = function fromSchema(schema) {
    return MarkdownTranslator.commonMarkFromSchema(schema);
  };

  MarkdownTranslator.commonMarkFromSchema = function commonMarkFromSchema(schema) {
    var translator = new MarkdownTranslator(schema);
    translator.parser = CommonMarkParser(schema);
    translator.serializer = CommonMarkSerializer(schema);
    return translator;
  };

  var _proto = MarkdownTranslator.prototype;

  _proto.nodeFromString = function nodeFromString(value) {
    return this.parser.parse(value);
  };

  _proto.stringFromNode = function stringFromNode(node) {
    return this.serializer.serialize(node, {
      tightLists: true
    });
  };

  return MarkdownTranslator;
}(TranslatorClass);

var DOMSerializer = /*#__PURE__*/function (_DOMSerializer2) {
  _inheritsLoose(DOMSerializer, _DOMSerializer2);

  function DOMSerializer() {
    return _DOMSerializer2.apply(this, arguments) || this;
  }

  DOMSerializer.nodesFromSchema = function nodesFromSchema(schema) {
    var result = gatherToDOM(schema.nodes);
    if (!result.text) result.text = function (node) {
      return node.text;
    };
    return result;
  };

  DOMSerializer.marksFromSchema = function marksFromSchema(schema) {
    return gatherToDOM(schema.marks);
  };

  return DOMSerializer;
}(DOMSerializer$1);

function gatherToDOM(obj) {
  var result = {};

  for (var name in obj) {
    var toDocument = obj[name].spec.toDocument;
    var toDOM = obj[name].spec.toDOM;
    if (toDocument) result[name] = toDocument;else if (toDOM) result[name] = toDOM;
  }

  return result;
}

var DOMTranslator = /*#__PURE__*/function (_TranslatorClass) {
  _inheritsLoose(DOMTranslator, _TranslatorClass);

  function DOMTranslator(schema) {
    var _this;

    _this = _TranslatorClass.call(this) || this;
    _this.schema = schema;
    _this.parser = DOMParser$1.fromSchema(schema);
    _this.serializer = DOMSerializer.fromSchema(schema);
    return _this;
  }

  DOMTranslator.fromSchema = function fromSchema(schema) {
    return new DOMTranslator(schema);
  };

  var _proto = DOMTranslator.prototype;

  _proto.nodeFromString = function nodeFromString(value) {
    var al;

    try {
      al = window.document.createRange().createContextualFragment(value);
    } catch (e) {
      al = new DOMParser().parseFromString(value, 'text/html');
    }

    return this.parser.parse(al);
  };

  _proto.stringFromNode = function stringFromNode(node) {
    var el = document.createElement('div');
    el.appendChild(this.serializer.serializeFragment(node.content));
    return el.innerHTML;
  };

  return DOMTranslator;
}(TranslatorClass);
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/


var buildTranslator = function buildTranslator(schema, format) {
  if (format === void 0) {
    format = 'markdown';
  }

  if (format === 'html') return DOMTranslator.fromSchema(schema);
  return MarkdownTranslator.fromSchema(schema);
};
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/


var commonPluginKey = /*#__PURE__*/new PluginKey('common');
var commonPlugin = /*#__PURE__*/new Plugin({
  key: commonPluginKey,
  state: {
    init: function init() {
      return {
        editorFocused: false
      };
    },
    apply: function apply(tr, prev) {
      if (tr.getMeta('editor_focused') === false) {
        return {
          editorFocused: false
        };
      }

      if (tr.getMeta('editor_focused')) {
        return {
          editorFocused: true
        };
      }

      return prev;
    }
  },
  props: {
    handleScrollToSelection: function handleScrollToSelection() {
      return true;
    },
    handleDOMEvents: {
      focus: function focus(view) {
        var state = view.state,
            dispatch = view.dispatch;
        dispatch(state.tr.setMeta('editor_focused', true));
        return false;
      },
      blur: function blur(view) {
        var state = view.state,
            dispatch = view.dispatch;
        dispatch(state.tr.setMeta('editor_focused', false));
        return false;
      }
    }
  }
});
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

function liftBlockquote(state, dispatch) {
  var range = getRangeForType(state, state.schema.nodes.blockquote);
  if (!range) return false;
  var target = liftTarget(range);
  if (!target) return false;

  if (dispatch) {
    dispatch(state.tr.lift(range, target)); //dont lift lists
  }

  return true;
}

var getRangeForType = function getRangeForType(state, listType) {
  var _state$selection = state.selection,
      $from = _state$selection.$from,
      $to = _state$selection.$to;
  var range = $from.blockRange($to, function (node) {
    return node.type == listType;
  });
  return range;
};
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/


function toggleBulletList(state, dispatch) {
  var lift = liftListItem(state.schema.nodes.list_item);
  var wrap = wrapInList(state.schema.nodes.bullet_list);
  var canDo = wrap(state, dispatch) || lift(state, dispatch);
  return canDo;
}

function toggleOrderedList(state, dispatch) {
  var lift = liftListItem(state.schema.nodes.list_item);
  var wrap = wrapInList(state.schema.nodes.ordered_list);
  return wrap(state, dispatch) || lift(state, dispatch);
}
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/


function deleteEmptyHeading(state, dispatch) {
  var $cursor = state.selection.$cursor;
  if (!$cursor) return false;
  var node = state.doc.nodeAt(Math.max($cursor.pos - 1, 0));
  if (!node) return false;
  if (node.type != state.schema.nodes.heading) return false;
  if (node.textContent.length) return false;

  if (dispatch) {
    var tr = state.tr;
    dispatch(tr // Replace the entire heading with an empty paragraph
    .replaceRangeWith($cursor.pos - 1, $cursor.pos + node.nodeSize - 1, state.schema.nodes.paragraph.create()) // Set the selection to be at the start of the paragraph
    .setSelection(new TextSelection(tr.doc.resolve(state.selection.head))).scrollIntoView());
  }

  return true;
}

function toggleHeader(nodeType, attrs, fallBackNodeType, fallbackAttrs) {
  return function (state, dispatch) {
    var _state$selection = state.selection,
        from = _state$selection.from,
        to = _state$selection.to;
    var firstTextblock = null;
    var firstPos = -1; // Find the first textblock

    state.doc.nodesBetween(from, to, function (node, pos) {
      if (firstTextblock) return false;

      if (node.isTextblock) {
        firstTextblock = node;
        firstPos = pos;
      }

      return true;
    });
    if (!firstTextblock || firstPos < 0) return false;
    var $firstPos = state.doc.resolve(firstPos);
    var index = $firstPos.index();
    var setAsParagraph = state.selection.$head.parent.attrs.level == attrs.level;
    var nextNodeType = setAsParagraph ? fallBackNodeType : nodeType;
    var nextAttrs = setAsParagraph ? fallbackAttrs : attrs;
    if (!$firstPos.parent.canReplaceWith(index, index + 1, nextNodeType)) return false;

    if (dispatch) {
      dispatch(state.tr.setBlockType(from, to, nextNodeType, nextAttrs).scrollIntoView());
    }

    return true;
  };
}
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/


function insertHr(state, dispatch) {
  var type = state.schema.nodes.horizontal_rule;

  if (dispatch) {
    dispatch(state.tr.replaceSelectionWith(type.create()).scrollIntoView());
  }

  return true;
}
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/


var hardBreakCmd = function hardBreakCmd(schema) {
  var br = schema.nodes.hard_break;
  return chainCommands(exitCode, function (state, dispatch) {
    dispatch(state.tr.replaceSelectionWith(br.create()).scrollIntoView());
    return true;
  });
};

var headingCmd = function headingCmd(level) {
  return function (schema) {
    var heading = schema.nodes.heading;
    return toggleHeader(heading, {
      level: level
    }, schema.nodes.paragraph, null);
  };
};

var KEYMAP_PLUGINS = [{
  __type: 'wysiwyg:keymap',
  name: 'Mod-z',
  command: function command() {
    return undo;
  }
}, {
  __type: 'wysiwyg:keymap',
  name: 'Backspace',
  command: function command() {
    return undoInputRule;
  }
}, {
  __type: 'wysiwyg:keymap',
  name: 'Mod-Shift-z',
  command: function command() {
    return redo;
  }
}, {
  __type: 'wysiwyg:keymap',
  name: 'Mod-y',
  command: function command() {
    return redo;
  },
  unlessMac: true
}, {
  __type: 'wysiwyg:keymap',
  name: 'Tab',
  command: function command() {
    return tab;
  }
}, {
  __type: 'wysiwyg:keymap',
  name: 'Shift-Tab',
  command: function command() {
    return shiftTab;
  }
}, {
  __type: 'wysiwyg:keymap',
  name: 'Mod-b',
  ifMark: 'strong',
  command: function command(schema) {
    return toggleMark(schema.marks.strong);
  }
}, {
  __type: 'wysiwyg:keymap',
  name: 'Mod-i',
  ifMark: 'em',
  command: function command(schema) {
    return toggleMark(schema.marks.em);
  }
}, {
  __type: 'wysiwyg:keymap',
  name: 'Mod-k',
  ifMark: 'link',
  command: function command(schema) {
    var toggleLink = toggleMark(schema.marks.link, {
      href: '',
      title: ''
    });
    return function (state, dispatch) {
      if (!state.selection.$cursor) {
        return toggleLink(state, dispatch);
      }

      return false;
    };
  }
}, {
  __type: 'wysiwyg:keymap',
  name: 'Mod-Enter',
  command: hardBreakCmd,
  ifNode: 'hard_break'
}, {
  __type: 'wysiwyg:keymap',
  name: 'Shift-Enter',
  command: hardBreakCmd,
  ifNode: 'hard_break'
}, {
  __type: 'wysiwyg:keymap',
  name: 'Ctrl-Enter',
  command: hardBreakCmd,
  ifNode: 'hard_break',
  ifMac: true
}, {
  __type: 'wysiwyg:keymap',
  name: 'Mod-Alt-1',
  command: /*#__PURE__*/headingCmd(1),
  ifNode: 'heading'
}, {
  __type: 'wysiwyg:keymap',
  name: 'Mod-Alt-2',
  command: /*#__PURE__*/headingCmd(2),
  ifNode: 'heading'
}, {
  __type: 'wysiwyg:keymap',
  name: 'Mod-Alt-3',
  command: /*#__PURE__*/headingCmd(3),
  ifNode: 'heading'
}, {
  __type: 'wysiwyg:keymap',
  name: 'Mod-Alt-4',
  command: /*#__PURE__*/headingCmd(4),
  ifNode: 'heading'
}, {
  __type: 'wysiwyg:keymap',
  name: 'Mod-Alt-5',
  command: /*#__PURE__*/headingCmd(5),
  ifNode: 'heading'
}, {
  __type: 'wysiwyg:keymap',
  name: 'Mod-Alt-6',
  command: /*#__PURE__*/headingCmd(6),
  ifNode: 'heading'
}, {
  // TODO: NOT WORKING
  __type: 'wysiwyg:keymap',
  name: 'Backspace',
  command: function command() {
    return deleteEmptyHeading;
  },
  ifNode: 'heading'
}, {
  __type: 'wysiwyg:keymap',
  name: 'Mod-Alt-7',
  command: function command() {
    return toggleOrderedList;
  },
  ifNode: 'ordered_list'
}, {
  __type: 'wysiwyg:keymap',
  name: 'Mod-Alt-8',
  command: function command() {
    return toggleBulletList;
  },
  ifNode: 'bullet_list'
}, {
  __type: 'wysiwyg:keymap',
  name: 'Mod-Alt-9',
  command: function command(schema) {
    return liftListItem(schema.nodes.list_item);
  },
  onCondition: function onCondition(schema) {
    return !!(schema.nodes.bullet_list || schema.nodes.ordered_list);
  }
}, {
  __type: 'wysiwyg:keymap',
  name: 'Mod-Alt-0',
  command: function command(schema) {
    return setBlockType(schema.nodes.code_block);
  },
  ifNode: 'code_block'
}, {
  __type: 'wysiwyg:keymap',
  name: 'ArrowLeft',
  command: function command() {
    return arrowHandler('left');
  },
  ifNodes: ['code_block', 'table']
}, {
  __type: 'wysiwyg:keymap',
  name: 'ArrowRight',
  command: function command() {
    return arrowHandler('right');
  },
  ifNodes: ['code_block', 'table']
}, {
  __type: 'wysiwyg:keymap',
  name: 'ArrowUp',
  command: function command() {
    return arrowHandler('up');
  },
  ifNodes: ['code_block', 'table']
}, {
  __type: 'wysiwyg:keymap',
  name: 'ArrowDown',
  command: function command() {
    return arrowHandler('down');
  },
  ifNodes: ['code_block', 'table']
}, {
  __type: 'wysiwyg:keymap',
  name: 'Mod-0',
  ifMark: 'code',
  command: function command(schema) {
    return toggleMark(schema.marks.code);
  }
}, {
  __type: 'wysiwyg:keymap',
  name: 'Mod->',
  ifNode: 'blockquote',
  command: function command(schema) {
    return wrapIn(schema.nodes.blockquote);
  }
}, {
  __type: 'wysiwyg:keymap',
  name: 'Mod-<',
  ifNode: 'blockquote',
  command: function command() {
    return liftBlockquote;
  }
}, {
  __type: 'wysiwyg:keymap',
  name: 'Mod-Alt-9',
  ifNode: 'paragraph',
  command: function command(schema) {
    return setBlockType(schema.nodes.paragraph);
  }
}, {
  __type: 'wysiwyg:keymap',
  name: 'Shift-Ctrl-0',
  ifNode: 'paragraph',
  command: function command(schema) {
    return setBlockType(schema.nodes.paragraph);
  }
}, {
  __type: 'wysiwyg:keymap',
  name: 'Mod-Enter',
  ifNode: 'horizontal_rule',
  command: function command() {
    return insertHr;
  }
}, {
  __type: 'wysiwyg:keymap',
  name: 'Enter',
  ifNode: 'list_item',
  command: function command(schema) {
    return splitListItem(schema.nodes.list_item);
  }
}, {
  __type: 'wysiwyg:keymap',
  name: 'Tab',
  ifNode: 'list_item',
  command: function command(schema) {
    return sinkListItem(schema.nodes.list_item);
  }
}, {
  __type: 'wysiwyg:keymap',
  name: 'Shift-Tab',
  ifNode: 'list_item',
  command: function command(schema) {
    return liftListItem(schema.nodes.list_item);
  }
}];

function arrowHandler(dir) {
  return function (state, dispatch, view) {
    if (view.endOfTextblock(dir)) {
      var side = dir == 'left' || dir == 'up' ? -1 : 1;
      var $head = state.selection.$head;
      var nextPos = Selection.near(state.doc.resolve(side > 0 ? $head.after() : $head.before()), side);

      if (nextPos.$head) {
        var name = nextPos.$head.parent.type.name;

        if (name == 'code_block' || name === 'table_header' || name === 'table_cell') {
          dispatch(state.tr.setSelection(nextPos));
          return true;
        }
      }
    }

    return false;
  };
}

var tab = /*#__PURE__*/goToCell(1);
var shiftTab = /*#__PURE__*/goToCell(-1);

function goToCell(dir) {
  return function (state, dispatch) {
    var table = state.schema.nodes.table;
    var parentTable = findParentNodeOfType(table)(state.selection);

    if (parentTable) {
      goToNextCell(1 * dir)(state, dispatch);
      return true;
    }

    return false;
  };
}

var mac = typeof navigator != 'undefined' ? /*#__PURE__*/ /Mac/.test(navigator.platform) : false;

function buildKeymap(schema) {
  var keys = _extends({}, baseKeymap);

  function bind(key, cmd) {
    if (keys[key]) {
      cmd = chainCommands(cmd, keys[key]);
    }

    keys[key] = cmd;
  }

  bind('Enter', chainCommands(createParagraphNear, liftEmptyBlock, splitBlock));
  findPlugins('wysiwyg:keymap', KEYMAP_PLUGINS).forEach(function (plugin) {
    var skip = false; // Exit early if this is a Mac, and it shouldn't be added for Mac.

    if (plugin.unlessMac && mac) skip = true; // Exit early if it is for a mark type that doesn't exist.

    if (plugin.ifMark && !schema.marks[plugin.ifMark]) skip = true; // Exit early if it is for a node type that doesn't exist.

    if (plugin.ifNode && !schema.nodes[plugin.ifNode]) skip = true;
    if (plugin.ifNodes && !plugin.ifNodes.some(function (n) {
      return schema.nodes[n];
    })) skip = true; // Exit if condition not met

    if (plugin.onCondition && !plugin.onCondition(schema)) skip = true; // Bind the command

    if (!skip) bind(plugin.name, plugin.command(schema));
  });
  return keys;
}
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/


function singleMarkCommand(markType, getAttrs) {
  // Version 1
  return function command(state, dispatch, match, start, end) {
    var attrs = getAttrs instanceof Function ? getAttrs(match) : getAttrs;
    var tr = state.tr;
    var offset = match[1].length;
    var textGroup = 2;

    if (match[textGroup]) {
      var textStart = start + 1 + offset;
      var textEnd = textStart + match[textGroup].length;
      var deleteStart = [textStart - 1, textStart];
      var nextChar = getNextChar(state, textEnd);
      var deleteEndEnd = nextChar ? 0 : 1;
      var deleteEnd = [textEnd, textEnd + deleteEndEnd]; // console.log({
      //   match,
      //   start,
      //   end,
      //   offset,
      //   textStart,
      //   textEnd,
      //   deleteStart,
      //   deleteEnd,
      // })

      tr["delete"].apply(tr, deleteEnd);
      tr["delete"].apply(tr, deleteStart);
      end = start + match[textGroup].length + offset;
    }

    tr.addMark(start + offset, end, markType.create(attrs));
    tr.removeStoredMark(markType);

    if (dispatch) {
      dispatch(tr);
    }

    return tr;
  };
}

function getNextChar(state, textEnd) {
  try {
    return state.doc.textBetween(textEnd + 1, textEnd + 2);
  } catch (e) {
    return '';
  }
}
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/


var star = '\\*';

var _double = function _double(boundary) {
  return new RegExp("" + boundary + boundary + "([^\r\n\t\f" + boundary + "} ](.*[^\r\n\t\f" + boundary + " ])?)" + boundary + boundary);
};

var single = function single(boundary) {
  return new RegExp("(^|[^" + boundary + "])" + boundary + "([^\r\n\t\f" + boundary + " ](.*[^\r\n\t\f" + boundary + " ])?)" + boundary);
};

var STRONG = /*#__PURE__*/_double(star);

var EM = /*#__PURE__*/single(star);

var S = /*#__PURE__*/_double('~');

var EM_UNDERSCORE = /*#__PURE__*/single('_');
var CODE = /*#__PURE__*/single('`');

function buildInputRules(schema) {
  var rules = [];
  var type;
  if (type = schema.nodes.blockquote) rules.push(blockQuoteRule(type));
  if (type = schema.nodes.ordered_list) rules.push(orderedListRule(type));
  if (type = schema.nodes.bullet_list) rules.push(bulletListRule(type));
  if (type = schema.nodes.code_block) rules.push(codeBlockRule(type));
  if (type = schema.nodes.heading) rules.push(headingRule(type, 6));
  if (type = schema.nodes.horizontal_rule) rules.push(horizontalRuleRule(type));
  var mark;

  if (mark = schema.marks.strong) {
    rules.push(strongStarRule(mark));
    rules.push(strongUnderRule(mark));
  }

  if (mark = schema.marks.strike) {
    rules.push(strikethroughRule(mark));
  }

  if (mark = schema.marks.em) {
    rules.push(emStarRule(mark));
    rules.push(emUnderRule(mark));
  }

  if (mark = schema.marks.code) rules.push(codeRule(mark));
  return rules;
}

function markInputRule(regexp, markType, getAttrs) {
  return new InputRule(regexp, function (state, match, start, end) {
    var attrs = getAttrs instanceof Function ? getAttrs(match) : getAttrs;
    var tr = state.tr;

    if (match[1]) {
      var textStart = start + match[0].indexOf(match[1]);
      var textEnd = textStart + match[1].length;
      if (textEnd < end) tr["delete"](textEnd, end);
      if (textStart > start) tr["delete"](start, textStart);
      end = start + match[1].length;
    }

    tr.addMark(start, end, markType.create(attrs));
    tr.removeStoredMark(markType);
    return tr;
  }); // todo: the typing broke this
}

function singleMarkInputRule(regexp, markType, getAttrs) {
  var command = singleMarkCommand(markType, getAttrs);
  return new InputRule(regexp, function (state, match, start, end) {
    return command(state, null, match, start, end);
  }); // todo: broke by new typings
}

function strongStarRule(markType) {
  return markInputRule(STRONG, markType, {});
}

function strikethroughRule(markType) {
  return markInputRule(S, markType, {});
}

function strongUnderRule(markType) {
  return markInputRule(_double('_'), markType, {});
}

function emStarRule(markType) {
  return singleMarkInputRule(EM, markType, {});
}

function emUnderRule(markType) {
  return singleMarkInputRule(EM_UNDERSCORE, markType, {});
}

function codeRule(markType) {
  return singleMarkInputRule(CODE, markType, {});
} // : (NodeType) → InputRule
// Given a blockquote node type, returns an input rule that turns `"> "`
// at the start of a textblock into a blockquote.


function blockQuoteRule(nodeType) {
  return wrappingInputRule(/^\s*>\s$/, nodeType);
} // : (NodeType) → InputRule
// Given a list node type, returns an input rule that turns a number
// followed by a dot at the start of a textblock into an ordered list.


function orderedListRule(nodeType) {
  return wrappingInputRule(/^(\d+)\.\s$/, nodeType, function (match) {
    return {
      order: +match[1]
    };
  }, function (match, node) {
    return node.childCount + node.attrs.order == +match[1];
  });
}

function horizontalRuleRule(nodeType) {
  return new InputRule(/^(---|___|\*\*\*)$/, function (state, _match, start, end) {
    return state.tr.replaceRangeWith(start, end, nodeType.create());
  });
} // : (NodeType) → InputRule
// Given a list node type, returns an input rule that turns a bullet
// (dash, plush, or asterisk) at the start of a textblock into a
// bullet list.


function bulletListRule(nodeType) {
  return wrappingInputRule(/^\s*([-+*])\s$/, nodeType);
} // : (NodeType) → InputRule
// Given a code block node type, returns an input rule that turns a
// textblock starting with three backticks into a code block.


function codeBlockRule(nodeType) {
  return textblockTypeInputRule(/^```([a-zA-Z]*)? $/, nodeType, function (match) {
    var language = match[1];

    if (language) {
      return {
        params: language
      };
    }

    return {};
  });
} // : (NodeType, number) → InputRule
// Given a node type and a maximum level, creates an input rule that
// turns up to that number of `#` characters followed by a space at
// the start of a textblock into a heading whose level corresponds to
// the number of `#` signs.


function headingRule(nodeType, maxLevel) {
  return textblockTypeInputRule(new RegExp('^(#{1,' + maxLevel + '})\\s$'), nodeType, function (match) {
    return {
      level: match[1].length
    };
  });
}
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/


function inputRules(schema) {
  return inputRules$1({
    rules: buildInputRules(schema)
  });
}
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/


function insertImage(state, dispatch, src) {
  var nodeType = state.schema.nodes['image'];
  var image = nodeType.createAndFill({
    src: src,
    alt: '',
    title: ''
  });

  if (dispatch) {
    dispatch(state.tr.replaceSelectionWith(image).scrollIntoView());
  }

  return true;
}

function insertImageList(state, dispatch, imageSrc) {
  if (dispatch) {
    var nodeType = state.schema.nodes['image'];
    var tr = state.tr;
    imageSrc.forEach(function (src) {
      var image = nodeType.createAndFill({
        src: src,
        alt: '',
        title: ''
      });
      tr.replaceSelectionWith(image);
    });
    dispatch(tr.scrollIntoView());
  }

  return true;
}
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/


var Identity = function Identity(str) {
  return str;
};

var ImageView = /*#__PURE__*/function () {
  function ImageView(node, view, previewUrl) {
    var _this = this;

    if (previewUrl === void 0) {
      previewUrl = Identity;
    }

    this.selectNode = function () {
      if (_this.img) {
        _this.img.style.outline = '4px solid #0084FF';

        _this.img.classList.add('tina-selected-image');
      }
    };

    this.deselectNode = function () {
      if (_this.img) {
        _this.img.style.outline = '';

        _this.img.classList.remove('tina-selected-image');
      }
    };

    this.destroy = function () {
      _this.deselectNode();
    };

    this.node = node;
    this.view = view;
    this.dom = document.createElement('span');
    this.dom.classList.add('tinacms-image-wrapper');
    this.img = document.createElement('img');
    var _node$attrs = node.attrs,
        src = _node$attrs.src,
        align = _node$attrs.align,
        alt = _node$attrs.alt,
        title = _node$attrs.title,
        width = _node$attrs.width,
        height = _node$attrs.height;
    this.img.src = previewUrl(src);
    if (height) this.img.style.height = height;
    if (width) this.img.style.width = width;
    if (align) this.img.classList.add("align-" + align);
    if (alt) this.img.alt = alt;
    if (title) this.img.title = title;
    this.dom.appendChild(this.img);
  }

  var _proto = ImageView.prototype;

  _proto.update = function update(node) {
    if (this.img) {
      var _node$attrs2 = node.attrs,
          alt = _node$attrs2.alt,
          title = _node$attrs2.title;
      if (alt) this.img.alt = alt;
      if (title) this.img.title = title;
    }

    return true;
  };

  return ImageView;
}();

var imagePluginKey = /*#__PURE__*/new PluginKey('image');

var setSelectionAtPos = function setSelectionAtPos(state, dispatch, pos) {
  dispatch(state.tr.setSelection(new NodeSelection(state.tr.doc.resolve(pos))));
};

var insertImageFiles = function insertImageFiles(editorView, data, uploadImages) {
  var files = [];

  for (var i = 0; i < data.files.length; i++) {
    var file = data.files[i];
    if (file.type.match('image.*')) files.push(file);
  }

  if (files.length) {
    var state = editorView.state,
        dispatch = editorView.dispatch;
    dispatch(state.tr.setMeta('loading_images', files.length));
    var uploadPromise = uploadImages(files);
    uploadPromise.then(function (urls) {
      if (urls === void 0) {
        urls = [];
      }

      dispatch(state.tr.setMeta('loading_images', 0));
      insertImageList(state, dispatch, urls);
      editorView.focus();
    });
    return true;
  }

  return false;
};

var imagePlugin = function imagePlugin(uploadImages, previewUrl) {
  return new Plugin({
    key: imagePluginKey,
    state: {
      init: function init() {
        return {
          selectedImage: undefined
        };
      },
      apply: function apply(tr, prev, _, newState) {
        if (tr.getMeta('loading_images') > 0) {
          var loadingImagesCount = tr.getMeta('loading_images');
          var div = document.createElement('div');

          for (var i = 0; i < loadingImagesCount; i++) {
            var childElement = document.createElement('div');
            childElement.classList.add('image_loading_indicator');
            div.appendChild(childElement);
          }

          return _extends({}, prev, {
            deco: DecorationSet.create(newState.doc, [Decoration.widget(newState.selection.$to.pos, div)])
          });
        }

        if (tr.getMeta('loading_images') === 0) {
          return _extends({}, prev, {
            deco: undefined
          });
        }

        if (prev && prev.selectedImage) {
          var pos = prev.selectedImage.pos;
          if (!tr.doc.nodeAt(pos)) return _extends({}, prev, {
            selectedImage: undefined
          });
        }

        var selectedImage = tr.getMeta('image_clicked');
        if (selectedImage) return _extends({}, prev, {
          selectedImage: selectedImage
        });
        if (selectedImage === false) return _extends({}, prev, {
          selectedImage: undefined
        });
        return prev;
      }
    },
    props: {
      nodeViews: {
        image: function image(node, view) {
          return new ImageView(node, view, previewUrl);
        }
      },
      decorations: function decorations(state) {
        return this.getState(state).deco;
      },
      handleKeyDown: function handleKeyDown(view, event) {
        var state = view.state,
            dispatch = view.dispatch;
        var selection = state.selection,
            schema = state.schema;

        if (event.key === 'Escape') {
          dispatch(state.tr.setMeta('image_clicked', false));
        } else if (event.key === 'Backspace' && selection.$to.nodeBefore && selection.$to.nodeBefore.type === schema.nodes.image) {
          setSelectionAtPos(state, dispatch, selection.$to.pos - 1);
          return true;
        } else if (event.key === 'Delete' && selection.$to.nodeAfter && selection.$to.nodeAfter.type === schema.nodes.image) {
          setSelectionAtPos(state, dispatch, selection.$to.pos);
          return true;
        }

        return false;
      },
      handleClickOn: function handleClickOn(view, _1, node, nodePos, _2, direct) {
        if (!direct) return false;
        var state = view.state,
            dispatch = view.dispatch;
        var image = view.state.schema.nodes.image;

        if (node.type === image) {
          dispatch(state.tr.setMeta('image_clicked', {
            pos: nodePos,
            node: node
          }));
        } else {
          dispatch(state.tr.setMeta('image_clicked', false));
        }

        return false;
      },
      handleDrop: function handleDrop(editorView, event, _, moved) {
        if (moved || !uploadImages) return false;
        event.preventDefault();
        var dataTransfer = event.dataTransfer;
        if (!dataTransfer) return false;
        return insertImageFiles(editorView, dataTransfer, uploadImages);
      },
      handlePaste: function handlePaste(editorView, event) {
        if (!uploadImages) return false;
        event.preventDefault();
        var clipboardData = event.clipboardData;
        if (!clipboardData) return false;
        return insertImageFiles(editorView, clipboardData, uploadImages);
      }
    }
  });
};

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n      pointer-events: none;\n      color: #d1d1d1;\n      fill: #d1d1d1;\n    "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n      color: var(--tina-color-primary);\n      fill: var(--tina-color-primary);\n      background-color: rgba(53, 50, 50, 0.05);\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n  background-color: ", ";\n  color: ", ";\n  fill: ", ";\n  border: 1px solid var(--tina-color-grey-2);\n  margin: -1px;\n  outline: none;\n  padding: 6px 4px;\n  transition: all 85ms ease-out;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  &:hover {\n    background-color: rgba(53, 50, 50, 0.09);\n  }\n  &:active {\n    color: var(--tina-color-primary);\n    fill: var(--tina-color-primary);\n    background-color: rgba(53, 50, 50, 0.05);\n  }\n  svg {\n    width: 20px;\n    height: 20px;\n  }\n  ", ";\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  flex: 1 1 32px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var MenuItem = /*#__PURE__*/css( /*#__PURE__*/_templateObject());
var MenuButton = /*#__PURE__*/styled.button( /*#__PURE__*/_templateObject2(), MenuItem, function (p) {
  return p.active ? 'rgba(53, 50, 50, 0.05)' : 'transparent';
}, function (p) {
  return p.active ? 'var(--tina-color-primary)' : 'var(--tina-color-grey-8)';
}, function (p) {
  return p.active ? 'var(--tina-color-primary)' : 'var(--tina-color-grey-8)';
}, function (props) {
  return props.active && css(_templateObject3());
}, function (props) {
  return props.disabled && css(_templateObject4());
});
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

var commandControl = function commandControl(command, Icon, // Fix type
_title, tooltip, focusOnCreate) {
  if (focusOnCreate === void 0) {
    focusOnCreate = true;
  }

  return function () {
    var _useEditorStateContex = useEditorStateContext(),
        editorView = _useEditorStateContex.editorView;

    var onClick = function onClick() {
      if (canDo()) {
        var view = editorView.view;
        command(view.state, view.dispatch);

        if (focusOnCreate) {
          view.focus();
        }
      }
    };

    var canDo = function canDo() {
      return command(editorView.view.state);
    };

    return React__default.createElement(MenuButton, {
      "data-tooltip": tooltip,
      onClick: onClick,
      disabled: !canDo()
    }, React__default.createElement(Icon, null));
  };
};
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/


function markControl(_ref) {
  var mark = _ref.mark,
      Icon = _ref.Icon,
      tooltip = _ref.tooltip,
      defaultAttrs = _ref.defaultAttrs,
      _ref$selectionOnly = _ref.selectionOnly,
      selectionOnly = _ref$selectionOnly === void 0 ? false : _ref$selectionOnly,
      _ref$noMix = _ref.noMix,
      noMix = _ref$noMix === void 0 ? [] : _ref$noMix,
      isDisabled = _ref.isDisabled,
      onClick = _ref.onClick;
  return function () {
    var _useEditorStateContex = useEditorStateContext(),
        editorView = _useEditorStateContex.editorView;

    var view = editorView.view;

    var markType = function markType(markName) {
      var schema = view.state.schema;
      return schema.marks[markName];
    };

    var isActive = function isActive() {
      return markIsActive(mark);
    };

    var markIsActive = function markIsActive(markName) {
      var state = view.state;
      var mark = markType(markName);
      var _state$selection = state.selection,
          from = _state$selection.from,
          $from = _state$selection.$from,
          to = _state$selection.to,
          empty = _state$selection.empty;
      if (empty) return !!mark.isInSet(state.storedMarks || $from.marks());else return state.doc.rangeHasMark(from, to, mark);
    };

    var isOptionDisabled = function isOptionDisabled() {
      if (isDisabled) return isDisabled(view);
      if (mark === 'image') if (selectionOnly) {
        var $cursor = view.state.selection.$cursor;
        return !!$cursor || isInCodeBlock() || isIncompatibleMarksAreActive();
      }
      return isInCodeBlock() || isIncompatibleMarksAreActive();
    };

    var isInCodeBlock = function isInCodeBlock() {
      var node = view.state.selection.$from.node(view.state.selection.$from.depth);
      return node.type === view.state.schema.nodes.code_block;
    };

    var isIncompatibleMarksAreActive = function isIncompatibleMarksAreActive() {
      return noMix.map(markIsActive).reduce(function (someMarkActive, nextMarkActive) {
        return nextMarkActive || someMarkActive;
      }, false);
    };

    var onOptionClick = function onOptionClick() {
      if (onClick) {
        onClick(view);
      }

      if (isOptionDisabled()) return;
      var state = view.state,
          dispatch = view.dispatch;

      if (state.selection.$cursor && selectionOnly) {
        return;
      }

      toggleMark(markType(mark), defaultAttrs)(state, dispatch);
    };

    if (!markType(mark)) {
      return null;
    }

    return createElement(MenuButton, {
      "data-tooltip": tooltip,
      "data-side": "top",
      onClick: onOptionClick,
      active: !isOptionDisabled() && isActive(),
      disabled: isOptionDisabled()
    }, createElement(Icon, null));
  };
}

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}

var MenuPortalContext = /*#__PURE__*/createContext(function () {
  return null;
});

function useMenuPortal() {
  return useContext(MenuPortalContext);
}

var MenuPortalProvider = function MenuPortalProvider(_ref) {
  var children = _ref.children;
  var wrapperRef = useRef(null);
  var MenuPortal = useCallback(function (props) {
    if (!wrapperRef.current) return null;
    return createPortal(props.children, wrapperRef.current);
  }, [wrapperRef.current]);
  return createElement(MenuPortalContext.Provider, {
    value: MenuPortal
  }, createElement(MenuPortalWrapper, {
    ref: wrapperRef
  }, children));
};

var MenuPortalWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$1());

function _templateObject3$1() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  left: ", "px;\n"]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$1() {
  var data = _taggedTemplateLiteralLoose(["\n      opacity: 1;\n      pointer-events: all;\n      transform: translate3d(0, 100%, 0) scale3d(1, 1, 1);\n    "]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\n  border-radius: var(--tina-radius-small);\n  border: 1px solid #efefef;\n  display: block;\n  position: absolute;\n  bottom: -4px;\n  left: 0;\n  transform: translate3d(0, 100%, 0) scale3d(0.5, 0.5, 1);\n  opacity: 0;\n  pointer-events: none;\n  transition: all 85ms ease-out;\n  transform-origin: 0 0;\n  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.12), 0px 4px 8px rgba(48, 48, 48, 0.1);\n  background-color: white;\n  overflow: hidden;\n\n  ", ";\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}

var MenuDropdown = /*#__PURE__*/styled(function (_ref) {
  var children = _ref.children,
      triggerRef = _ref.triggerRef,
      styleProps = _objectWithoutPropertiesLoose(_ref, ["children", "open", "triggerRef", "innerRef"]);

  var MenuPortal = useMenuPortal();
  var menuPortalRef = useRef(null);

  var _React$useState = useState(0),
      menuOffset = _React$useState[0],
      setMenuOffset = _React$useState[1];

  useEffect(function () {
    if (triggerRef.current && menuPortalRef.current) {
      var menuDropdownBoundingBox = triggerRef.current.getBoundingClientRect();
      var menuPortalBoundingBox = menuPortalRef.current.getBoundingClientRect();
      setMenuOffset(menuDropdownBoundingBox.x - menuPortalBoundingBox.x);
    }
  }, [triggerRef.current, menuPortalRef.current]);
  return createElement(MenuPortal, null, createElement("div", {
    ref: menuPortalRef
  }, createElement(Offset, {
    offset: menuOffset
  }, createElement("div", Object.assign({}, styleProps), children))));
})( /*#__PURE__*/_templateObject$2(), function (props) {
  return props.open && css(_templateObject2$1());
});
var Offset = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject3$1(), function (props) {
  return props.offset;
});

function _templateObject2$2() {
  var data = _taggedTemplateLiteralLoose(["\n      color: var(--tina-color-primary);\n      fill: var(--tina-color-primary);\n      background-color: rgba(53, 50, 50, 0.05);\n    "]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  padding: 8px 16px;\n  transition: all 85ms ease-out;\n  cursor: pointer;\n  &:first-child {\n    padding-top: var(--tina-padding-small);\n  }\n  &:last-child {\n    padding-bottom: var(--tina-padding-small);\n  }\n  &:hover {\n    background-color: var(--tina-color-grey-1);\n    color: var(--tina-color-primary);\n  }\n  &:active {\n    color: var(--tina-color-primary);\n    fill: var(--tina-color-primary);\n    background-color: rgba(53, 50, 50, 0.05);\n  }\n  ", ";\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}

var MenuOption = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$3(), function (props) {
  return props.active && css(_templateObject2$2());
});

function _templateObject14() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteralLoose(["\n  display: none;\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteralLoose(["\n      padding: 0;\n      border: none;\n      border-radius: var(--tina-radius-small);\n      border: 1px solid var(--tina-color-grey-2);\n    "]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  width: 100%;\n  min-width: 200px;\n  padding: var(--tina-padding-big) 0;\n  margin-bottom: var(--tina-padding-small);\n  border-radius: var(--tina-radius-big);\n  border: 3px dashed var(--tina-color-grey-3);\n  cursor: pointer;\n\n  ", ";\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n  font-size: var(--tina-font-size-2);\n  text-align: center;\n  line-height: 1.2;\n  color: var(--tina-color-grey-10);\n  max-width: 120px;\n  display: block;\n  margin: 0 auto;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin: 0 -4px;\n  width: calc(100% + 8px);\n\n  ", " {\n    flex: 1 0 auto;\n    margin: 0 4px;\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n  background: var(--tina-color-grey-1);\n  padding: var(--tina-padding-small);\n  font-family: var(--tina-font-family);\n\n  * {\n    font-family: inherit;\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  font-size: var(--tina-font-size-1);\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  line-height: 1.35;\n  color: var(--tina-color-grey-8);\n  margin-bottom: 8px;\n  text-overflow: ellipsis;\n  width: 100%;\n  overflow: hidden;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  width: 100%;\n  margin: 0;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  margin-top: -7px;\n  svg {\n    width: 50px;\n    height: auto;\n    fill: var(--tina-color-primary);\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$1() {
  var data = _taggedTemplateLiteralLoose([""]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$2() {
  var data = _taggedTemplateLiteralLoose(["\n  background: none;\n  border: none;\n  outline: none;\n  color: var(--tina-color-primary);\n  cursor: pointer;\n  transition: all 80ms ease-out;\n  font-size: var(--tina-font-size-1);\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  line-height: 1.35;\n  padding: 0;\n\n  &:hover {\n    text-decoration: underline;\n    text-decoration-color: var(--tina-color-primary-light);\n  }\n"]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$3() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin-bottom: var(--tina-padding-small);\n"]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$4() {
  var data = _taggedTemplateLiteralLoose(["\n  background: none;\n  border: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  outline: none;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n  position: absolute;\n  top: 18px;\n  right: 18px;\n  border-radius: var(--tina-radius-big);\n  box-shadow: var(--tina-shadow-small);\n  background-color: var(--tina-color-grey-0);\n  border: 1px solid var(--tina-color-grey-2);\n  cursor: pointer;\n  transition: all 85ms ease-out;\n\n  &:hover {\n    background-color: var(--tina-color-grey-1);\n  }\n\n  svg {\n    fill: var(--tina-color-primary);\n    width: 22px;\n    height: 22px;\n  }\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}

var Menu = function Menu(_ref) {
  var uploadImages = _ref.uploadImages;
  var menuButtonRef = useRef();

  var _useEditorStateContex = useEditorStateContext(),
      editorView = _useEditorStateContex.editorView;

  var _useState = useState(false),
      displayUrlInput = _useState[0],
      setDisplayUrlInput = _useState[1];

  var _useState2 = useState(''),
      imageUrl = _useState2[0],
      setImageUrl = _useState2[1];

  var _useState3 = useState(false),
      showImageModal = _useState3[0],
      setShowImageModal = _useState3[1];

  var _useState4 = useState(false),
      uploading = _useState4[0],
      setUploading = _useState4[1];

  if (!uploadImages) return null;

  var uploadImageFile = function uploadImageFile(file) {
    setUploading(true);
    var uploadPromise = uploadImages([file]);
    uploadPromise.then(function (urls) {
      if (urls === void 0) {
        urls = [];
      }

      setImageUrl(urls[0]);
      setUploading(false);
    });
  };

  var insertImageInEditor = function insertImageInEditor() {
    if (!editorView) return;
    var _editorView$view = editorView.view,
        state = _editorView$view.state,
        dispatch = _editorView$view.dispatch;
    insertImage(state, dispatch, imageUrl);
    editorView.view.focus();
    setShowImageModal(false);
    setImageUrl('');
  };

  var uploadSelectedImage = function uploadSelectedImage(event) {
    var files = event.target.files;

    if (files[0]) {
      uploadImageFile(files[0]);
    }
  };

  var stopDefault = function stopDefault(evt) {
    evt.preventDefault();
    evt.stopPropagation();
  }; // Check if property name is files or items
  // IE uses 'files' instead of 'items'


  var onImageDrop = function onImageDrop(evt) {
    stopDefault(evt);
    var _evt$dataTransfer = evt.dataTransfer,
        items = _evt$dataTransfer.items,
        files = _evt$dataTransfer.files;
    var data = items || files;
    var dataIsItems = !!items;

    for (var i = 0; i < data.length; i += 1) {
      if ((!dataIsItems || data[i].kind === 'file') && data[i].type.match('^image/')) {
        var file = dataIsItems ? data[i].getAsFile() : data[i];

        if (file) {
          uploadImageFile(file);
        }
      }
    }
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (event.key === 'Escape') setShowImageModal(false);
  };

  var handleCloseModal = function handleCloseModal() {
    setImageUrl('');
    setShowImageModal(!showImageModal);
  };

  return React__default.createElement(React__default.Fragment, null, React__default.createElement(MenuButton, {
    ref: menuButtonRef,
    onClick: handleCloseModal
  }, React__default.createElement(MediaIcon, null)), React__default.createElement(MenuDropdown, {
    triggerRef: menuButtonRef,
    open: showImageModal,
    onKeyDown: handleKeyDown
  }, React__default.createElement(Dismissible, {
    click: true,
    escape: true,
    disabled: !showImageModal,
    onDismiss: function onDismiss() {
      setShowImageModal(false);
    }
  }, React__default.createElement(ImageModalContent, null, React__default.createElement(StyledLabel, {
    htmlFor: "fileInput"
  }, React__default.createElement(FileUploadInput, {
    id: "fileInput",
    onChange: uploadSelectedImage,
    type: "file",
    accept: "image/*"
  }), React__default.createElement(UploadSection, {
    onDragEnter: stopDefault,
    onDragOver: stopDefault,
    onDrop: onImageDrop,
    uploading: uploading,
    imageUrl: imageUrl
  }, imageUrl && React__default.createElement(React__default.Fragment, null, React__default.createElement(ClearImageButton, {
    onMouseDown: function onMouseDown(evt) {
      setImageUrl('');
      evt.stopPropagation();
    }
  }, React__default.createElement(CloseIcon, null)), React__default.createElement(CurrentImage, {
    src: imageUrl,
    alt: "uploaded_image"
  })), !imageUrl && React__default.createElement(React__default.Fragment, null, React__default.createElement(UploadIconWrapper, null, React__default.createElement(UploadIcon, null)), React__default.createElement(UploadText, null, !uploading && "Drag and drop or click to upload", uploading && 'Image uploading...')))), React__default.createElement(UrlInputWrapper, null, displayUrlInput && React__default.createElement(React__default.Fragment, null, React__default.createElement(UrlInput, {
    onMouseDown: function onMouseDown(evt) {
      return evt.stopPropagation();
    }
  }, React__default.createElement(ImageInputLabel, {
    onClick: function onClick() {
      setDisplayUrlInput(false);
    }
  }, "Or Enter Image URL"), React__default.createElement(Input, {
    small: true,
    onChange: function onChange(evt) {
      return setImageUrl(evt.target.value);
    },
    value: imageUrl
  }))), !displayUrlInput && React__default.createElement(React__default.Fragment, null, React__default.createElement(UrlInputTrigger, {
    onClick: function onClick() {
      setDisplayUrlInput(true);
    }
  }, "Or Enter Image URL"))), React__default.createElement(ImageModalActions, null, React__default.createElement(Button, {
    small: true,
    onClick: handleCloseModal
  }, "Cancel"), React__default.createElement(Button, {
    primary: true,
    small: true,
    onClick: insertImageInEditor
  }, "Insert"))))));
};

var ClearImageButton = /*#__PURE__*/styled.button( /*#__PURE__*/_templateObject$4());
var UrlInputWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$3());
var UrlInputTrigger = /*#__PURE__*/styled.button( /*#__PURE__*/_templateObject3$2());
var UrlInput = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject4$1());
var UploadIconWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject5());
var CurrentImage = /*#__PURE__*/styled.img( /*#__PURE__*/_templateObject6());
var ImageInputLabel = /*#__PURE__*/styled.label( /*#__PURE__*/_templateObject7());
var ImageModalContent = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject8());
var ImageModalActions = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject9(), Button);
var UploadText = /*#__PURE__*/styled.span( /*#__PURE__*/_templateObject10());
var UploadSection = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject11(), function (props) {
  return props.imageUrl !== '' && css(_templateObject12());
});
var FileUploadInput = /*#__PURE__*/styled.input( /*#__PURE__*/_templateObject13());
var StyledLabel = /*#__PURE__*/styled.label( /*#__PURE__*/_templateObject14());

var findElementOffsetTop = function findElementOffsetTop(element, parent) {
  var target = element;
  var offsetTop = target.offsetTop;

  while (target.offsetParent && (!parent || target.offsetParent !== parent)) {
    target = target.offsetParent;
    offsetTop += target.offsetTop;
  }

  return offsetTop;
};

var findElementOffsetLeft = function findElementOffsetLeft(element, parent) {
  var target = element;
  var offsetLeft = target.offsetLeft;

  while (target.offsetParent && (!parent || target.offsetParent !== parent)) {
    target = target.offsetParent;
    offsetLeft += target.offsetLeft;
  }

  return offsetLeft;
};
/**
 * Function will check if mark is present in selection.
 */


var isMarkPresent = function isMarkPresent(state, markType) {
  return !!getMarkPresent(state, markType);
};
/**
 * Function will check if mark is present in selection.
 */


var getMarkPresent = function getMarkPresent(state, markType) {
  var selection = state.selection;
  var anchor = selection.anchor,
      head = selection.head;
  var start;
  var end;

  if (anchor < head) {
    start = anchor;
    end = head;
  } else {
    start = head;
    end = anchor;
  }

  start = selection.empty ? start : start + 1;
  var mark = markType.isInSet(state.doc.resolve(start).marks());
  if (!mark) return false;
  var markPresent = mark;

  for (; start < end && markPresent; start += 1) {
    if (!markType.isInSet(state.doc.resolve(start).marks())) markPresent = undefined;
  }

  return markPresent;
};

function _templateObject10$1() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 48px;\n  height: 28px;\n  opacity: 0;\n  margin: 0;\n  cursor: ", ";\n"]);

  _templateObject10$1 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9$1() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 48px;\n  height: 28px;\n  border-radius: var(--tina-radius-big);\n  background-color: white;\n  border: 1px solid var(--tina-color-grey-2);\n  pointer-events: none;\n  margin-left: -2px;\n  span {\n    position: absolute;\n    border-radius: var(--tina-radius-big);\n    left: 2px;\n    top: 50%;\n    width: calc(28px - 6px);\n    height: calc(28px - 6px);\n    background: ", ";\n    transform: translate3d(", ", -50%, 0);\n    transition: all 150ms ease-out;\n  }\n"]);

  _templateObject9$1 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8$1() {
  var data = _taggedTemplateLiteralLoose(["\n  background: none;\n  color: inherit;\n  padding: 0;\n  opacity: ", ";\n  outline: none;\n  height: 28px;\n  pointer-events: ", ";\n  font-size: var(--tina-font-size-1);\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  line-height: 1.35;\n  color: var(--tina-color-grey-8);\n"]);

  _templateObject8$1 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7$1() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  position: relative;\n  margin: 0 0 0.5rem 0;\n"]);

  _templateObject7$1 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$1() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: white;\n  border: 1px solid var(--tina-color-grey-2);\n  color: var(--tina-color-primary);\n  &:hover {\n    background-color: var(--tina-color-grey-1);\n    opacity: 1;\n  }\n"]);

  _templateObject6$1 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$1() {
  var data = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  border: 0;\n  border-radius: var(--tina-radius-big);\n  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.12);\n  background-color: var(--tina-color-primary);\n  color: white;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 85ms ease-out;\n  font-size: var(--tina-font-size-0);\n  padding: 8px 20px;\n  margin-left: 8px;\n  &:hover {\n    background-color: var(--tina-color-primary-light);\n  }\n  &:active {\n    background-color: var(--tina-color-primary-dark);\n  }\n"]);

  _templateObject5$1 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$2() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 4px;\n"]);

  _templateObject4$2 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$3() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  background-color: white;\n  border-radius: var(--tina-radius-small);\n  font-size: var(--tina-font-size-1);\n  line-height: 1.35;\n  transition: all 85ms ease-out;\n  padding: 8px 12px;\n  border: 1px solid var(--tina-color-grey-2);\n  width: 100%;\n  margin: 0 0 8px 0;\n  outline: none;\n  box-shadow: 0 0 0 2px transparent;\n\n  &:hover {\n    box-shadow: 0 0 0 2px var(--tina-color-grey-3);\n  }\n\n  &:focus {\n    box-shadow: 0 0 0 2px var(--tina-color-primary);\n  }\n\n  &::placeholder {\n    font-size: var(--tina-font-size-2);\n    color: #cfd3d7;\n  }\n"]);

  _templateObject3$3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$4() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  font-size: var(--tina-font-size-1);\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  color: var(--tina-color-grey-8);\n  margin-bottom: 3px;\n"]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$5() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: #f6f6f9;\n  position: absolute;\n  border-radius: var(--tina-radius-small);\n  border: 1px solid var(--tina-color-grey-2);\n  filter: drop-shadow(0px 4px 8px rgba(48, 48, 48, 0.1))\n    drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.12));\n  transform-origin: 50% 0;\n  overflow: visible;\n  padding: 12px;\n  z-index: 10;\n  width: 16rem;\n  left: ", ";\n  top: ", ";\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}

var ImageEdit = function ImageEdit() {
  var _useEditorStateContex = useEditorStateContext(),
      editorView = _useEditorStateContex.editorView;

  var view = editorView.view;

  var _imagePluginKey$getSt = imagePluginKey.getState(view.state),
      selectedImage = _imagePluginKey$getSt.selectedImage;

  if (!selectedImage) return null;
  var node = selectedImage.node,
      pos = selectedImage.pos;
  var link = view.state.schema.marks.link;
  var linkMark = node.marks.find(function (mark) {
    return mark.type === link;
  });

  var _useState = useState(node.attrs.title),
      title = _useState[0],
      setTitle = _useState[1];

  var _useState2 = useState(node.attrs.alt),
      alt = _useState2[0],
      setAlt = _useState2[1];

  var _useState3 = useState(linkMark && linkMark.attrs.title),
      linkTitle = _useState3[0],
      setLinkTitle = _useState3[1];

  var _useState4 = useState(linkMark && linkMark.attrs.href),
      linkSrc = _useState4[0],
      setLinkSrc = _useState4[1];

  var _view$coordsAtPos = view.coordsAtPos(pos),
      top = _view$coordsAtPos.top,
      left = _view$coordsAtPos.left;

  var _useState5 = useState(top),
      modalTop = _useState5[0],
      setModalTop = _useState5[1];

  var _useState6 = useState(left),
      modalLeft = _useState6[0],
      setModalLeft = _useState6[1];

  var wrapperRef = useRef();
  var inputRef = useRef();
  var imageRef = useRef();

  var _useState7 = useState(!!linkMark),
      linked = _useState7[0],
      toggleLinked = _useState7[1];

  function positionImage(scroll) {
    var image = document.getElementsByClassName('tina-selected-image')[0];
    var wysiwygWrapper = document.getElementsByClassName('wysiwyg-wrapper')[0];

    if (image && (imageRef.current !== image || scroll) && wrapperRef.current) {
      imageRef.current = image;
      var wrapperDimensions = wrapperRef.current.getBoundingClientRect();
      setModalLeft(image.clientWidth / 2 + findElementOffsetLeft(image, wysiwygWrapper) - wrapperDimensions.width / 2);
      setModalTop(findElementOffsetTop(image, wysiwygWrapper));
    }
  }

  useEffect(function () {
    var debouncedPositionImage = debounce(function () {
      return positionImage(true);
    }, 10);
    window.addEventListener('scroll', debouncedPositionImage);
    return function () {
      window.removeEventListener('scroll', debouncedPositionImage);
    };
  });
  useEffect(function () {
    setLinkTitle(linkMark ? linkMark.attrs.title : '');
    setLinkSrc(linkMark ? linkMark.attrs.href : '');
    toggleLinked(!!linkMark);
  }, [linkMark]);
  useEffect(function () {
    setTitle(node.attrs.title);
    setAlt(node.attrs.alt);
  }, [selectedImage.node]);
  useEffect(function () {
    setTimeout(function () {
      if (inputRef.current) inputRef.current.focus();
    });
  }, [inputRef]);
  useEffect(positionImage);

  var updateNodeAttrs = function updateNodeAttrs() {
    var dispatch = view.dispatch,
        state = view.state;
    var image = state.schema.nodes.image;
    var link = state.schema.marks.link;
    var tr = state.tr;

    if (linked && (linkSrc || linkTitle)) {
      tr.addMark(pos, pos + 1, link.create({
        href: linkSrc,
        title: linkTitle
      }));
    } else {
      tr.removeMark(pos, pos + 1, link);
    }

    tr.setNodeMarkup(pos, image, _extends({}, node.attrs, {
      alt: alt,
      title: title
    })).setSelection(new NodeSelection(tr.doc.resolve(pos)));
    dispatch(tr);
    closeImageSettings();
    view.focus();
  };

  var closeImageSettings = function closeImageSettings() {
    var dispatch = view.dispatch,
        state = view.state;
    dispatch(state.tr.setMeta('image_clicked', false));
    setTitle('');
    setAlt('');
    setLinkTitle('');
    setLinkSrc('');
    view.focus();
  };

  var handleKeyPress = function handleKeyPress(evt) {
    if (evt.key === 'Escape') closeImageSettings();
    if (evt.key === 'Enter') updateNodeAttrs();
  };

  return React__default.createElement(TinaReset, null, React__default.createElement(LinkPopup, {
    top: modalTop,
    left: modalLeft,
    ref: wrapperRef,
    onKeyDown: handleKeyPress
  }, React__default.createElement(LinkLabel, null, "Title"), React__default.createElement(LinkInput, {
    placeholder: "Enter Title",
    type: 'text',
    ref: inputRef,
    value: title,
    onChange: function onChange(evt) {
      return setTitle(evt.target.value);
    }
  }), React__default.createElement(LinkLabel, null, "Alt"), React__default.createElement(LinkInput, {
    placeholder: "Enter Alt Text",
    type: 'text',
    value: alt,
    onChange: function onChange(evt) {
      return setAlt(evt.target.value);
    }
  }), React__default.createElement(ToggleElement, null, React__default.createElement(ToggleInput, {
    id: "toggleImageLink",
    onChange: function onChange() {
      toggleLinked(!linked);

      if (!linked) {
        setLinkTitle('');
        setLinkSrc('');
      }
    },
    type: "checkbox"
  }), React__default.createElement(ToggleLabel, {
    htmlFor: "toggleImageLink",
    role: "switch"
  }, "Insert Link", React__default.createElement(ToggleSwitch, {
    checked: linked
  }, React__default.createElement("span", null)))), linked && React__default.createElement(React__default.Fragment, null, React__default.createElement(LinkLabel, null, "Link Title"), React__default.createElement(LinkInput, {
    placeholder: "Enter Link Title",
    type: 'text',
    value: linkTitle,
    onChange: function onChange(evt) {
      return setLinkTitle(evt.target.value);
    }
  }), React__default.createElement(LinkLabel, null, "Link URL"), React__default.createElement(LinkInput, {
    placeholder: "Enter Link URL",
    type: 'text',
    value: linkSrc,
    onChange: function onChange(evt) {
      return setLinkSrc(evt.target.value);
    }
  })), React__default.createElement(LinkActions, null, React__default.createElement(CancelLink, {
    onClick: closeImageSettings
  }, "Cancel"), React__default.createElement(SaveLink, {
    onClick: updateNodeAttrs
  }, "Save"))));
};

var LinkPopup = /*#__PURE__*/styled.span( /*#__PURE__*/_templateObject$5(), function (_ref) {
  var left = _ref.left;
  return left + "px";
}, function (_ref2) {
  var top = _ref2.top;
  return top + "px";
});
var LinkLabel = /*#__PURE__*/styled.label( /*#__PURE__*/_templateObject2$4());
var LinkInput = /*#__PURE__*/styled.input( /*#__PURE__*/_templateObject3$3());
var LinkActions = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject4$2());
var SaveLink = /*#__PURE__*/styled.button( /*#__PURE__*/_templateObject5$1());
var CancelLink = /*#__PURE__*/styled(SaveLink)( /*#__PURE__*/_templateObject6$1());
var ToggleElement = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject7$1());
var ToggleLabel = /*#__PURE__*/styled.label( /*#__PURE__*/_templateObject8$1(), function (props) {
  return props.disabled ? '0.4' : '1';
}, function (props) {
  return props.disabled ? 'none' : 'inherit';
});
var ToggleSwitch = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject9$1(), function (p) {
  return p.checked ? 'var(--tina-color-primary)' : 'var(--tina-color-grey-3)';
}, function (p) {
  return p.checked ? '20px' : '0';
});
var ToggleInput = /*#__PURE__*/styled.input( /*#__PURE__*/_templateObject10$1(), function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
});

function _templateObject$6() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  padding: 64px;\n  background-color: rgba(100, 100, 100, 0.07);\n"]);

  _templateObject$6 = function _templateObject() {
    return data;
  };

  return data;
}

var Loader = function Loader() {
  var markerImageLoader = document.getElementsByClassName('image_loading_indicator');
  if (!markerImageLoader.length) return null;
  var loaders = [];

  for (var i = 0; i < markerImageLoader.length; i++) {
    loaders.push(ReactDOM__default.createPortal(React__default.createElement(ImagePlaceholder, null), markerImageLoader[0]));
  }

  return React__default.createElement(React__default.Fragment, null, loaders);
};

var ImagePlaceholder = /*#__PURE__*/styled(function (_ref) {
  var styleProps = _extends({}, _ref);

  return React__default.createElement("div", Object.assign({}, styleProps), React__default.createElement(LoadingDots, {
    color: 'var(--tina-color-primary)'
  }));
})( /*#__PURE__*/_templateObject$6());
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

function makeCodeBlock(state, dispatch) {
  return setBlockType(state.schema.nodes.code_block)(state, dispatch);
}

var Menu$1 = /*#__PURE__*/commandControl(makeCodeBlock, CodeIcon, 'Codeblock', 'Codeblock', false); //codeblock focusing messes with scroll

/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

function exitCodeHard(state, dispatch) {
  var $head = state.selection.$head;
  var above = $head.node(-1);
  var after = $head.indexAfter(-1);
  var type = above.defaultContentType(after);

  if (dispatch) {
    var pos = $head.before();
    var tr = state.tr.replaceWith(pos, pos, type.createAndFill());
    tr.setSelection(Selection.near(tr.doc.resolve(pos), 1));
    dispatch(tr.scrollIntoView());
  }

  return true;
}

function exitCodeUp(state, dispatch) {
  var _state$selection = state.selection,
      $head = _state$selection.$head,
      $anchor = _state$selection.$anchor;
  if (!$head.parent.type.spec.code || !$head.sameParent($anchor)) return false;
  var above = $head.node(-1);
  var after = $head.indexAfter(-1);
  var type = above.defaultContentType(after);
  if (!above.canReplaceWith(after, after, type)) return false;

  if (dispatch) {
    var pos = $head.before();
    var tr = state.tr.replaceWith(pos, pos, type.createAndFill());
    tr.setSelection(Selection.near(tr.doc.resolve(pos), -1));
    dispatch(tr.scrollIntoView());
  }

  return true;
}

function deleteEmptyCodeblock(cm) {
  return function (state, dispatch) {
    // Todo: It would be nice to have a way to get this without CodeMirror being passed in.
    var pos = cm.getCursor();
    var code = cm.getValue();
    var codeWithoutInvisibles = code.replace(/[ \r\n]/g, '');
    var shouldRemove = !codeWithoutInvisibles;

    if (!(pos.line == 0 && pos.ch == 0 && shouldRemove)) {
      return false;
    }

    var $from = state.selection.$from;

    if (dispatch) {
      // I hate my life
      var schema = state.schema,
          tr = state.tr;
      dispatch(tr // Replace the entire codeblock with an empty paragraph
      .replaceRangeWith($from.pos - 1, $from.pos + code.length + 1, schema.nodes.paragraph.create()) // Set the seleciton to be at the start of the paragram
      .setSelection(new TextSelection(tr.doc.resolve($from.pos))));
    }

    return true;
  };
}
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/


var ssr = typeof navigator == 'undefined';
var mac$1 = typeof navigator != 'undefined' ? /*#__PURE__*/ /Mac/.test(navigator.platform) : false;
var CodeMirror = null;

if (!ssr) {
  CodeMirror = /*#__PURE__*/require('codemirror');
}

var CodeBlockView = /*#__PURE__*/function () {
  function CodeBlockView(node, view, getPos) {
    var _this = this;

    this.node = node;
    this.view = view;
    this.getPos = getPos;
    this.updating = false;

    this.onCursorActivity = function () {
      if (!_this.updating) {
        _this.forwardSelection();
      }
    };
    /**
     * When CodeMirror's Selection is changed, a transaction is dispatched to
     * update the ProseMirror editor's Selection.
     */


    this.forwardSelection = function () {
      if (!_this.cm.hasFocus()) return;
      var state = _this.view.state;

      var selection = _this.asProseMirrorSelection(state.doc);

      if (!selection.eq(state.selection)) {
        _this.view.dispatch(state.tr.setSelection(selection));
      }
    };

    this.onChange = function () {
      if (!_this.updating) {
        _this.valueChanged();
      }
    };

    if (ssr) return;
    this.cm = this.setupCodeMirror(node);
    this.dom = this.cm.getWrapperElement();
    setTimeout(function () {
      return _this.cm.refresh();
    }, 20);
    this.cm.on('cursorActivity', this.onCursorActivity);
    this.cm.on('changes', this.onChange);
    this.cm.on('focus', this.forwardSelection);
  }
  /**
   * If the code block is changed, a ProseMirror transaction is dispatched
   * to keep the two editors in sync.
   */


  var _proto = CodeBlockView.prototype;

  _proto.valueChanged = function valueChanged() {
    var change = computeChange(this.node.textContent, this.cm.getValue());

    if (change) {
      var codeBlockStart = this.getPos() + 1;
      var schema = this.view.state.schema;
      var tr = this.view.state.tr.replaceWith(codeBlockStart + change.from, codeBlockStart + change.to, change.text ? schema.text(change.text) : null);
      this.view.dispatch(tr); // Damn typings :(
    }
  }
  /**
   * Creates a ProseMirror TextSelection based off the CodeMirror selection.
   */
  ;

  _proto.asProseMirrorSelection = function asProseMirrorSelection(doc) {
    var offset = this.getPos() + 1;
    var anchor = this.cm.indexFromPos(this.cm.getCursor('anchor')) + offset;
    var head = this.cm.indexFromPos(this.cm.getCursor('head')) + offset;
    return TextSelection.create(doc, anchor, head);
  }
  /**
   * Set's the CodeMirror selection given the anchor and head.
   */
  ;

  _proto.setSelection = function setSelection(anchor, head) {
    this.cm.focus();
    this.updating = true;
    this.cm.setSelection(this.cm.posFromIndex(anchor), this.cm.posFromIndex(head));
    this.updating = false;
  }
  /**
   * Creates a new instance of CodeMirror from a ProseMirror Node
   */
  ;

  _proto.setupCodeMirror = function setupCodeMirror(node) {
    return CodeMirror(null, {
      value: node.textContent,
      lineNumbers: true,
      extraKeys: this.codeMirrorKeymap(),
      mode: node.attrs.params,
      theme: 'forestry'
    });
  }
  /**
   * Generates a Keymap for the CodeMirror instance.
   */
  ;

  _proto.codeMirrorKeymap = function codeMirrorKeymap() {
    var _this2 = this,
        _CodeMirror$normalize;

    var view = this.view;
    var mod = mac$1 ? 'Cmd' : 'Ctrl';
    return CodeMirror.normalizeKeyMap((_CodeMirror$normalize = {
      Up: function Up() {
        return _this2.maybeEscape('line', -1);
      },
      Left: function Left() {
        return _this2.maybeEscape('char', -1);
      },
      Down: function Down() {
        return _this2.maybeEscape('line', 1);
      },
      Right: function Right() {
        return _this2.maybeEscape('char', 1);
      },
      Backspace: function Backspace() {
        if (!deleteEmptyCodeblock(_this2.cm)(_this2.view.state, _this2.view.dispatch)) {
          return CodeMirror.Pass;
        }

        _this2.view.focus();
      }
    }, _CodeMirror$normalize[mod + "-Z"] = function Z() {
      return undo(view.state, view.dispatch);
    }, _CodeMirror$normalize["Shift-" + mod + "-Z"] = function ShiftZ() {
      return redo(view.state, view.dispatch);
    }, _CodeMirror$normalize[mod + "-Shift-Enter"] = function ShiftEnter() {
      var pos = _this2.cm.getCursor();

      if (_this2.cm.somethingSelected() || pos.line != _this2.cm.firstLine()) {
        return CodeMirror.Pass;
      }

      if (view.state.selection.$anchor.parentOffset) {
        var _pos = view.state.selection.$anchor.pos;
        view.dispatch(view.state.tr.setSelection(Selection.near(_this2.view.state.doc.resolve(_pos - 1), -1)));
      }

      if (exitCodeUp(view.state, view.dispatch)) {
        view.focus();
      }

      return true;
    }, _CodeMirror$normalize['Shift-Enter'] = function ShiftEnter() {
      var pos = _this2.cm.getCursor();

      if (_this2.cm.somethingSelected() || pos.line != _this2.cm.lastLine()) {
        return CodeMirror.Pass;
      }

      if (view.state.selection.$anchor.parentOffset) {
        var _pos2 = view.state.selection.$anchor.pos;
        view.dispatch(view.state.tr.setSelection(Selection.near(_this2.view.state.doc.resolve(_pos2 - 1), -1)));
      }

      if (exitCode(view.state, view.dispatch)) {
        return view.focus();
      } else if (exitCodeHard(view.state, view.dispatch)) {
        return view.focus();
      }
    }, _CodeMirror$normalize));
  };

  _proto.maybeEscape = function maybeEscape(unit, dir) {
    var pos = this.cm.getCursor();

    if (this.cm.somethingSelected() || pos.line != (dir < 0 ? this.cm.firstLine() : this.cm.lastLine()) || unit == 'char' && pos.ch != (dir < 0 ? 0 : this.cm.getLine(pos.line).length)) {
      return CodeMirror.Pass;
    }

    var targetPos = this.getPos() + (dir < 0 ? 0 : this.node.nodeSize);
    var selection = Selection.near(this.view.state.doc.resolve(targetPos), dir);
    var atEndOfDocument = !(selection.$from.pos + 1 < this.view.state.doc.content.size);

    if (atEndOfDocument) {
      return CodeMirror.Pass;
    }

    this.view.dispatch(this.view.state.tr.setSelection(selection));
    this.view.focus();
  }
  /**
   * When the Prosemirror Node is updated, compute the change between the
   * ProseMirror and CodeMirror. Then update CodeMirror to match ProseMirror.
   */
  ;

  _proto.update = function update(node) {
    if (node.type != this.node.type) return false;
    this.node = node;
    var change = computeChange(this.cm.getValue(), node.textContent);

    if (change) {
      this.updating = true;
      this.cm.replaceRange(change.text, this.cm.posFromIndex(change.from), this.cm.posFromIndex(change.to));
      this.updating = false;
    }

    return true;
  }
  /**
   * Called by ProseMirror when the CodeView is clicked.
   */
  ;

  _proto.selectNode = function selectNode() {
    this.cm.focus();
  }
  /**
   * Prevents Events in here from bubbling.
   */
  ;

  _proto.stopEvent = function stopEvent() {
    return true;
  };

  return CodeBlockView;
}();

function computeChange(oldVal, newVal) {
  if (oldVal == newVal) return null;
  var start = 0;
  var oldEnd = oldVal.length;
  var newEnd = newVal.length;

  while (start < oldEnd && oldVal.charCodeAt(start) == newVal.charCodeAt(start)) {
    ++start;
  }

  while (oldEnd > start && newEnd > start && oldVal.charCodeAt(oldEnd - 1) == newVal.charCodeAt(newEnd - 1)) {
    oldEnd--;
    newEnd--;
  }

  return {
    from: start,
    to: oldEnd,
    text: newVal.slice(start, newEnd)
  };
}
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/


var codeBlockPluginKey = /*#__PURE__*/new PluginKey('image');
var codeBlockPlugin = /*#__PURE__*/new Plugin({
  key: codeBlockPluginKey,
  props: {
    nodeViews: {
      image: function image(node, view, getPos) {
        return new CodeBlockView(node, view, getPos);
      }
    }
  }
});
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

var exitCodeMarkOnArrowRight = function exitCodeMarkOnArrowRight(view, event) {
  // If user is at end of current line and there is a code mark an arrow-right will
  // take user out of the code mark.
  if (event.key !== 'ArrowRight') return false;
  var _view$state = view.state,
      selection = _view$state.selection,
      schema = _view$state.schema;
  var code = schema.marks.code;
  if (!code.isInSet(selection.$to.marks())) return false;
  var selectionIsAtEnd = selection.$to.node().nodeSize - 2 === selection.$to.parentOffset;
  if (!selectionIsAtEnd) return false;
  var state = view.state,
      dispatch = view.dispatch;
  dispatch(state.tr.insertText(' ', selection.$to.pos).removeMark(selection.$to.pos, selection.$to.pos + 1, code));
  return true;
};

var inlinePluginKey = /*#__PURE__*/new PluginKey('inline');
var inlinePlugin = /*#__PURE__*/new Plugin({
  key: inlinePluginKey,
  props: {
    handleKeyDown: function handleKeyDown(view, event) {
      return exitCodeMarkOnArrowRight(view, event);
    }
  }
});
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

var Menu$2 = function Menu() {
  return createElement(Fragment, null, createElement(BoldControl, null), createElement(ItalicControl, null), createElement(StrikeControl, null));
};

var BoldControl = /*#__PURE__*/markControl({
  mark: 'strong',
  Icon: BoldIcon,
  tooltip: 'Bold'
});
var ItalicControl = /*#__PURE__*/markControl({
  mark: 'em',
  Icon: ItalicIcon,
  tooltip: 'Italic'
});
var StrikeControl = /*#__PURE__*/markControl({
  mark: 'strike',
  Icon: StrikethroughIcon,
  tooltip: 'Strike'
});
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

/**
 * Taken from https://stackoverflow.com/questions/3809401/what-is-a-good-regular-expression-to-match-a-url
 *
 * Todo: Might be a good idea to replace this with a library that does it really well.
 *
 * @type {RegExp}
 */

var IMG_REGEX = /\.(jpe?g|png)/;
var HTTP_LINK_REGEX = /\bhttps?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:;%_\+.,~#?&//=]*)/g;

var linkify = function linkify(fragment) {
  var linkified = [];
  fragment.forEach(function (child) {
    if (child.isText) {
      var text = child.text;
      var pos = 0;
      var match;
      var link = child.type.schema.marks['link'];
      var img = child.type.schema.nodes['image'];
      var matches = [];

      while (match = HTTP_LINK_REGEX.exec(text)) {
        var start = match.index;
        var end = start + match[0].length;
        matches.push({
          start: start,
          end: end
        });
      }

      matches.forEach(function (_ref) {
        var start = _ref.start,
            end = _ref.end; // simply copy across the text from before the match

        if (start > 0) {
          linkified.push(child.cut(pos, start));
        }

        var attrs;
        var urlText = text.slice(start, end);

        if (IMG_REGEX.test(urlText)) {
          attrs = {
            src: urlText,
            title: '',
            alt: ''
          };
          linkified.push(img.create(attrs));
        } else {
          attrs = {
            href: urlText,
            title: urlText
          };
          linkified.push(child.cut(start, end).mark(link.create(attrs).addToSet(child.marks)));
        }

        pos = end;
      }); // copy over whatever is left

      if (pos < text.length) {
        linkified.push(child.cut(pos));
      }
    } else {
      linkified.push(child.copy(linkify(child.content)));
    }
  });
  return Fragment$1.fromArray(linkified);
};
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/


var linkPluginKey = /*#__PURE__*/new PluginKey('image');

function linkPlugin() {
  var shiftKey;
  return new Plugin({
    key: linkPluginKey,
    state: {
      init: function init() {
        return {
          showLinkForm: false
        };
      },
      apply: function apply(tr, prev, _, state) {
        if (tr.getMeta('show_link_toolbar') === false) {
          return {
            show_link_toolbar: false
          };
        }

        if (tr.getMeta('show_link_toolbar')) {
          return {
            show_link_toolbar: true
          };
        }

        var _commonPluginKey$getS = commonPluginKey.getState(state),
            editorFocused = _commonPluginKey$getS.editorFocused;

        if (isMarkPresent(state, state.schema.marks.link)) {
          return {
            show_link_toolbar: true
          };
        } else if (editorFocused) {
          return {
            show_link_toolbar: false
          };
        }

        return prev;
      }
    },
    props: {
      transformPasted: function transformPasted(slice) {
        if (shiftKey) {
          return slice;
        }

        return new Slice(linkify(slice.content), slice.openStart, slice.openEnd);
      },
      handleKeyDown: function handleKeyDown(_x, e) {
        shiftKey = e.shiftKey;
        return false;
      },
      handleClickOn: function handleClickOn(view, _1) {
        var dispatch = view.dispatch,
            state = view.state;
        var tr = state.tr,
            schema = state.schema;

        if (!isMarkPresent(state, schema.marks.link)) {
          dispatch(tr.setMeta('show_link_toolbar', false));
        }

        return false;
      }
    }
  });
}
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/


var Menu$3 = /*#__PURE__*/markControl({
  mark: 'link',
  Icon: LinkIcon,
  tooltip: 'Link',
  selectionOnly: true,
  defaultAttrs: {
    href: '',
    title: ''
  },
  noMix: ['code'],
  isDisabled: function isDisabled(view) {
    if (view.state.selection.empty) return true;
    return isMarkPresent(view.state, view.state.schema.marks.link) || !!imagePluginKey.getState(view.state).selectedImage;
  },
  onClick: function onClick(view) {
    var state = view.state,
        dispatch = view.dispatch;
    return dispatch(state.tr.setMeta('show_link_toolbar', true));
  }
});
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

function markExtend($cursor, markType) {
  window.$cursor = $cursor;
  var startIndex = $cursor.index();
  var endIndex = $cursor.indexAfter(); // Clicked outside edge of tag.

  if (startIndex === $cursor.parent.childCount) {
    startIndex--;
    endIndex--;
  }

  var mark = markType.isInSet($cursor.parent.child(startIndex).marks);
  if (!mark) return; // TODO: This might be a problem.

  var hasMark = function hasMark(index) {
    return mark.isInSet($cursor.parent.child(index).marks);
  };

  while (startIndex > 0 && hasMark(startIndex - 1)) {
    startIndex--;
  }

  while (endIndex < $cursor.parent.childCount && hasMark(endIndex)) {
    endIndex++;
  }

  var startPos = $cursor.start();
  var endPos = startPos;

  for (var i = 0; i < endIndex; i++) {
    var size = $cursor.parent.child(i).nodeSize;
    if (i < startIndex) startPos += size;
    endPos += size;
  }

  return {
    from: startPos,
    to: endPos,
    mark: mark
  };
}

function unmountLinkForm(view) {
  var dispatch = view.dispatch,
      state = view.state;
  dispatch(state.tr.setMeta('show_link_toolbar', false));
}
/**
 * Finds the Link currently being edited and sets it's attributes.
 *
 * @param {EditorState} state
 * @param {(tr: Transaction) => void} dispatch
 * @param {Object} attrs
 */


function updateLinkBeingEdited(state, dispatch, attrs) {
  if (dispatch) {
    var selection = state.selection,
        schema = state.schema,
        tr = state.tr;
    var mark = markExtend(selection.$anchor, schema.marks.link);

    if (mark) {
      tr.addMark(mark.from, mark.to, schema.marks.link.create(attrs));
    }

    tr.setMeta('show_link_toolbar', false);
    dispatch(tr);
  }

  return true;
}

function removeLinkBeingEdited(state, dispatch) {
  if (dispatch) {
    var selection = state.selection,
        schema = state.schema,
        tr = state.tr;
    var mark = markExtend(selection.$anchor, schema.marks.link);

    if (mark) {
      tr.removeMark(mark.from, mark.to, mark.mark);
    }

    tr.setMeta('show_link_toolbar', false);
    dispatch(tr);
  }

  return true;
}

function _templateObject7$2() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: white;\n  border: 1px solid var(--tina-color-grey-2);\n  color: #0084ff;\n  &:hover {\n    background-color: #f6f6f9;\n    opacity: 1;\n  }\n"]);

  _templateObject7$2 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$2() {
  var data = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  border: 0;\n  border-radius: var(--tina-radius-big);\n  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.12);\n  background-color: #0084ff;\n  color: white;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 85ms ease-out;\n  font-size: var(--tina-font-size-0);\n  padding: 8px 20px;\n  margin-left: 8px;\n  &:hover {\n    background-color: #2296fe;\n  }\n  &:active {\n    background-color: #0574e4;\n  }\n"]);

  _templateObject6$2 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$2() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 4px;\n"]);

  _templateObject5$2 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$3() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  background-color: white;\n  border-radius: var(--tina-radius-small);\n  font-size: var(--tina-font-size-1);\n  line-height: 1.35;\n  transition: all 85ms ease-out;\n  padding: 8px 12px;\n  border: 1px solid var(--tina-color-grey-2);\n  width: 100%;\n  margin: 0 0 8px 0;\n  outline: none;\n  box-shadow: 0 0 0 2px transparent;\n\n  &:hover {\n    box-shadow: 0 0 0 2px var(--tina-color-grey-3);\n  }\n\n  &:focus {\n    box-shadow: 0 0 0 2px #0084ff;\n  }\n\n  &::placeholder {\n    font-size: var(--tina-font-size-2);\n    color: #cfd3d7;\n  }\n"]);

  _templateObject4$3 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$4() {
  var data = _taggedTemplateLiteralLoose(["\n  display: block;\n  font-size: var(--tina-font-size-1);\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  color: var(--tina-color-grey-8);\n  margin-bottom: 3px;\n"]);

  _templateObject3$4 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$5() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: #f6f6f9;\n  position: relative;\n  height: max-content;\n  border-radius: var(--tina-radius-small);\n  border: 1px solid var(--tina-color-grey-2);\n  filter: drop-shadow(0px 4px 8px rgba(48, 48, 48, 0.1))\n    drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.12));\n  transform-origin: 50% 0;\n  animation: ", " 85ms ease-out both 1;\n  overflow: visible;\n  padding: 12px;\n  z-index: 10;\n"]);

  _templateObject2$5 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$7() {
  var data = _taggedTemplateLiteralLoose(["\n  0% {\n    transform: scale3d(0.5,0.5,1)\n  }\n  100% {\n    transform: scale3d(1, 1, 1);\n  }\n"]);

  _templateObject$7 = function _templateObject() {
    return data;
  };

  return data;
}

var InnerForm = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(InnerForm, _React$Component);

  function InnerForm() {
    var _this;

    _this = _React$Component.apply(this, arguments) || this;
    _this.state = {
      href: _this.props.href || '',
      title: _this.props.title || ''
    };

    _this.setHref = function (_ref) {
      var value = _ref.target.value;
      return _this.setState(function () {
        return {
          href: value
        };
      });
    };

    _this.setTitle = function (_ref2) {
      var value = _ref2.target.value;
      return _this.setState(function () {
        return {
          title: value
        };
      });
    };

    _this.save = function () {
      return _this.props.onChange(_this.state);
    };

    _this.onEnterSave = function (e) {
      if (e.key === 'Enter') {
        _this.save();
      }
    };

    _this.onEscapeCancel = function (e) {
      if (e.keyCode === 27) {
        _this.props.cancel();
      }
    };

    return _this;
  }

  var _proto = InnerForm.prototype;

  _proto.componentDidMount = function componentDidMount() {
    document.addEventListener('keydown', this.onEscapeCancel);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener('keydown', this.onEscapeCancel);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(props) {
    var href = props.href,
        title = props.title;
    this.setState(function () {
      return {
        href: href,
        title: title
      };
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        removeLink = _this$props.removeLink,
        _this$props$style = _this$props.style,
        style = _this$props$style === void 0 ? {} : _this$props$style;
    var _this$state = this.state,
        href = _this$state.href,
        title = _this$state.title;
    return createElement(LinkPopup$1, {
      style: _extends({}, style)
    }, createElement(LinkLabel$1, null, "Title"), createElement(LinkInput$1, {
      placeholder: "Enter Title",
      type: 'text',
      value: title,
      onChange: this.setTitle,
      onKeyPress: this.onEnterSave
    }), createElement(LinkLabel$1, null, "URL"), createElement(LinkInput$1, {
      placeholder: "Enter URL",
      type: 'text',
      value: href,
      onChange: this.setHref,
      onKeyPress: this.onEnterSave
    }), createElement(LinkActions$1, null, createElement(DeleteLink, {
      onClick: removeLink
    }, "Delete"), createElement(SaveLink$1, {
      onClick: this.save
    }, "Save")));
  };

  return InnerForm;
}(Component);

var LinkPopupKeyframes = /*#__PURE__*/keyframes( /*#__PURE__*/_templateObject$7());
var LinkPopup$1 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$5(), LinkPopupKeyframes);
var LinkLabel$1 = /*#__PURE__*/styled.label( /*#__PURE__*/_templateObject3$4());
var LinkInput$1 = /*#__PURE__*/styled.input( /*#__PURE__*/_templateObject4$3());
var LinkActions$1 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject5$2());
var SaveLink$1 = /*#__PURE__*/styled.button( /*#__PURE__*/_templateObject6$2());
var DeleteLink = /*#__PURE__*/styled(SaveLink$1)( /*#__PURE__*/_templateObject7$2());

function _templateObject2$6() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: ", ";\n  left: ", ";\n  margin-top: 3px;\n  transform: translate3d(-50%, -100%, 0);\n  width: 16px;\n  height: 13px;\n  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\n  background-color: #f6f6f9;\n  z-index: 100;\n"]);

  _templateObject2$6 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$8() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n"]);

  _templateObject$8 = function _templateObject() {
    return data;
  };

  return data;
}

var width = 240;

var LinkForm = function LinkForm() {
  var _useEditorStateContex = useEditorStateContext(),
      editorView = _useEditorStateContex.editorView;

  var _useState = useState(undefined),
      position = _useState[0],
      setPosition = _useState[1];

  if (!editorView) return null;
  var view = editorView.view;
  var linkPluginState = linkPluginKey.getState(view.state);
  var _view$state$selection = view.state.selection,
      anchor = _view$state$selection.anchor,
      head = _view$state$selection.head;
  var selState = anchor < head ? anchor : head;
  var node = view.state.selection.empty ? view.domAtPos(selState).node : view.domAtPos(selState + 1).node;
  var clickTarget = node.parentNode;

  var onChange = function onChange(attrs) {
    updateLinkBeingEdited(view.state, view.dispatch, attrs);
  };

  var onCancel = function onCancel() {
    unmountLinkForm(view);
  };

  var wrapperRef = createRef(); // eslint-disable-next-line react-hooks/rules-of-hooks

  useEffect(function () {
    if (!clickTarget || !wrapperRef.current) {
      setPosition(undefined);
      return;
    }

    var left = calcLeftOffset(clickTarget, wrapperRef.current, width);
    var top = "calc(32px + " + (findElementOffsetTop(clickTarget) - findElementOffsetTop(wrapperRef.current)) + "px)";
    var arrowOffset = calcArrowLeftOffset(clickTarget, wrapperRef.current);
    setPosition({
      arrowOffset: arrowOffset,
      left: left,
      top: top
    });
  }, [linkPluginState]);

  if (!linkPluginState.show_link_toolbar) {
    return null;
  }

  var _ref = position || {},
      arrowOffset = _ref.arrowOffset,
      left = _ref.left,
      top = _ref.top;

  var state = view.state,
      dispatch = view.dispatch;
  var href = '';
  var title = '';
  var linkMark = getMarkPresent(state, state.schema.marks.link);

  if (linkMark) {
    href = linkMark.attrs.href;
    title = linkMark.attrs.title;
  }

  return createElement("div", {
    ref: wrapperRef,
    style: {
      position: 'absolute'
    }
  }, position && createElement(TinaReset, null, createElement(LinkFormWrapper, null, createElement(LinkArrow, {
    offset: arrowOffset,
    top: top
  }), createElement(InnerForm, {
    style: {
      left: left,
      top: top,
      width: width + "px"
    },
    removeLink: function removeLink() {
      return removeLinkBeingEdited(state, dispatch);
    },
    onChange: onChange,
    href: href,
    title: title,
    cancel: onCancel
  }))));
};

var LinkFormWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$8());
var LinkArrow = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$6(), function (p) {
  return p.top;
}, function (p) {
  return p.offset;
});
/**
 * Calculates the leftOffset of the form.
 *
 * It centers the form on the link, unless the form would
 * show up outside of the window, in which case the offset is the edge
 * of the editor.
 *
 * @param {HTMLElement} clickTarget
 * @param {HTMLElement} renderTarget
 * @param {number} minWidth
 * @returns {string}
 */

function calcLeftOffset(clickTarget, renderTarget, minWidth) {
  var ow_ct = clickTarget.offsetWidth;
  var ol_ct = findElementOffsetLeft(clickTarget);
  var ow_rt = renderTarget.parentElement.offsetWidth;
  var ol_rt = findElementOffsetLeft(renderTarget);
  var ol = ol_ct - ol_rt + ow_ct / 2 - minWidth / 2;
  var leftEdgeOutsideView = ol < -ol_rt;

  if (leftEdgeOutsideView) {
    return "-8px";
  }

  var rightEdgeOutsideView = ol + minWidth > ow_rt;

  if (rightEdgeOutsideView) {
    return "calc(" + (ol - (ol + minWidth - ow_rt)) + "px + 8px)";
  }

  return ol + "px";
}

function calcArrowLeftOffset(clickTarget, renderTarget, _minWidth) {
  var ow_ct = clickTarget.offsetWidth;
  var ol_ct = findElementOffsetLeft(clickTarget);
  var ol_rt = findElementOffsetLeft(renderTarget);
  var ol = ol_ct - ol_rt + ow_ct / 2;
  return ol + "px";
}
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/


var buildCellSelection = function buildCellSelection(pos, classes, tableMap, table, state) {
  if (classes.includes('tina_table_header_ext_top_left')) return buildTableSelection(pos, tableMap, table, state.doc);
  if (classes.includes('tina_table_header_ext_left')) return buildColumnSelection(pos, tableMap, table, state.doc);
  if (classes.includes('tina_table_header_ext_top')) return buildRowSelection(pos, tableMap, table, state.doc);
};

var buildColumnSelection = function buildColumnSelection(pos, tableMap, table, doc) {
  var width = tableMap.width;
  var colStart = tableMap.map.findIndex(function (c) {
    return c === pos - table.start;
  });
  return new CellSelection(doc.resolve(tableMap.map[colStart + width - 1] + table.start), doc.resolve(pos));
};

var buildRowSelection = function buildRowSelection(pos, tableMap, table, doc) {
  var width = tableMap.width,
      height = tableMap.height;
  var rowStart = tableMap.map.findIndex(function (c) {
    return c === pos - table.start;
  });
  return new CellSelection(doc.resolve(tableMap.map[rowStart + width * (height - 1)] + table.start), doc.resolve(pos));
};

var buildTableSelection = function buildTableSelection(pos, tableMap, table, doc) {
  return new CellSelection(doc.resolve(tableMap.map[tableMap.map.length - 1] + table.start), doc.resolve(pos));
};

var buildExtendedHeaders = function buildExtendedHeaders(tableNode, selection) {
  var tableMap = TableMap.get(tableNode.node);
  var colSelection = selection.isColSelection && selection.isColSelection();
  var rowSelection = selection.isRowSelection && selection.isRowSelection();
  var decorations = buildExtendedTableHeaders(tableNode, colSelection, rowSelection);
  decorations = [].concat(decorations, buildExtendedColumnHeaders(tableNode, tableMap, selection, colSelection));
  decorations = [].concat(decorations, buildExtendedRowHeaders(tableNode, tableMap, selection, rowSelection));
  return decorations;
};

var buildExtendedColumnHeaders = function buildExtendedColumnHeaders(tableNode, tableMap, selection, colSelection) {
  var decorations = [];
  var cellMap = tableMap.map;

  var _loop = function _loop(i) {
    var div = document.createElement('div');
    div.classList.add('tina_table_header_ext_top');

    if (colSelection && selection.ranges.some(function (r) {
      return r.$from.pos === tableNode.start + cellMap[i] + 1;
    })) {
      div.classList.add('tina_table_header_ext_top_selected');
    }

    decorations.push(Decoration.widget(tableNode.start + cellMap[i] + 1, div));
  };

  for (var i = 0; i < tableMap.width; i++) {
    _loop(i);
  }

  return decorations;
};

var buildExtendedRowHeaders = function buildExtendedRowHeaders(tableNode, tableMap, selection, rowSelection) {
  var decorations = [];
  var cellMap = tableMap.map;

  var _loop2 = function _loop2(i) {
    var div = document.createElement('div');
    div.classList.add('tina_table_header_ext_left');

    if (rowSelection && selection.ranges.some(function (r) {
      return r.$from.pos === tableNode.start + cellMap[i * tableMap.width] + 1;
    })) {
      div.classList.add('tina_table_header_ext_left_selected');
    }

    decorations.push(Decoration.widget(tableNode.start + cellMap[i * tableMap.width] + 1, div));
  };

  for (var i = 0; i < tableMap.height; i++) {
    _loop2(i);
  }

  return decorations;
};

var buildExtendedTableHeaders = function buildExtendedTableHeaders(tableNode, colSelection, rowSelection) {
  var decorations = [];
  var div = document.createElement('div');
  div.classList.add('tina_table_header_ext_top_left');

  if (colSelection && rowSelection) {
    div.classList.add('tina_table_header_ext_top_left_selected');
  }

  decorations.push(Decoration.widget(tableNode.start + 2, div));
  return decorations;
};
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/


var tablePluginKey = /*#__PURE__*/new PluginKey('table');
var tablePlugin = /*#__PURE__*/new Plugin({
  key: tablePluginKey,
  state: {
    init: function init() {
      return {
        deco: DecorationSet.empty
      };
    },
    apply: function apply(tr, prev, oldState, newState) {
      if (tr.getMeta('image_clicked') === false) return prev;
      var selection = newState.selection;

      if (selection) {
        var table = newState.schema.nodes.table;
        var tableNode = findParentNodeOfType(table)(selection);

        if (tableNode) {
          var selectionNotChanged = selection === oldState.selection;
          var tableNotChanged = (tableNode && tableNode.node.nodeSize) === (prev.selectedTable && prev.selectedTable.node.nodeSize) && (tableNode && tableNode.start) === (prev.selectedTable && prev.selectedTable.start);
          if (selectionNotChanged && tableNotChanged) return prev;
          var decorations = buildExtendedHeaders(tableNode, selection);
          if (decorations.length) return {
            deco: DecorationSet.create(newState.doc, decorations),
            tableMap: TableMap.get(tableNode.node),
            selectedTable: tableNode
          };
        }
      }

      return {
        deco: DecorationSet.empty
      };
    }
  },
  props: {
    decorations: function decorations(state) {
      return this.getState(state).deco;
    },

    /**
     * When extended table header is clicked, corresponding column or row should be selected.
     */
    handleClickOn: function handleClickOn(view, _1, _2, nodePos, event, direct) {
      if (!direct) return false;
      var targetClasses = event.target.classList;
      var state = view.state,
          dispatch = view.dispatch;
      var tablePluginState = tablePluginKey.getState(state);
      var tableMap = tablePluginState.tableMap,
          selectedTable = tablePluginState.selectedTable;
      var cellSelection = buildCellSelection(nodePos, targetClasses.value, tableMap, selectedTable, state);
      if (cellSelection) dispatch(state.tr.setSelection(cellSelection));
      return false;
    }
  }
});
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

var createCell = function createCell(cellType, cellContent) {
  if (cellContent) return cellType.createChecked(null, cellContent);
  return cellType.createAndFill();
};

var insertTable = function insertTable(state, dispatch) {
  if (!dispatch) return true;
  var _state$schema$nodes = state.schema.nodes,
      tableCell = _state$schema$nodes.table_cell,
      tableHeader = _state$schema$nodes.table_header,
      tableRow = _state$schema$nodes.table_row,
      table = _state$schema$nodes.table;
  var rowsCount = 3;
  var colsCount = 3;
  var cells = [];
  var headerCells = [];

  for (var i = 0; i < colsCount; i += 1) {
    headerCells.push(createCell(tableHeader));
    cells.push(createCell(tableCell));
  }

  var rows = [];

  for (var _i = 0; _i < rowsCount; _i += 1) {
    rows.push(tableRow.createChecked(null, _i === 0 ? headerCells : cells));
  }

  var newTable = table.createChecked(null, rows);
  var selection = state.selection,
      tr = state.tr;
  var $from = selection.$from,
      $to = selection.$to;
  dispatch(tr.replaceWith($from.pos, $to.pos, newTable).scrollIntoView());
  return true;
};
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/


function insertTableCmd(state, dispatch) {
  var table = state.schema.nodes.table;
  var selection = state.selection;
  var tableParent = findParentNodeOfType(table)(selection);
  if (tableParent) return false;
  return insertTable(state, dispatch);
}

var Menu$4 = /*#__PURE__*/commandControl(insertTableCmd, TableIcon, 'Table', 'Table');
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

function buildEditorState(schema, translator, value, uploadImages, previewUrl) {
  return EditorState.create({
    schema: schema,
    doc: translator.nodeFromString(value),
    plugins: [commonPlugin, inlinePlugin, inputRules(schema), keymap(buildKeymap(schema)), history(), linkPlugin(), dropCursor({
      width: 2,
      color: 'rgb(0, 132, 255)'
    }), gapCursor(), tableEditing(), tablePlugin, imagePlugin(uploadImages, previewUrl), codeBlockPlugin]
  });
}

function byType(__type) {
  return function (plugin) {
    return plugin.__type === __type;
  };
}

function findPlugins(type, plugins) {
  return plugins.filter(byType(type));
}
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/


var buildEditor = function buildEditor(input, el, imageProps, setEditorView, format) {
  if (imageProps === void 0) {
    imageProps = {};
  }

  var schema = buildSchema();
  var _imageProps = imageProps,
      upload = _imageProps.upload,
      previewUrl = _imageProps.previewUrl;
  var translator = buildTranslator(schema, format);
  if (!el) return {};
  /**
   * Create a new Prosemirror EditorView on in the DOM
   */

  var view = new EditorView(el, {
    /**
     * The initial state of the Wysiwyg
     */
    state: buildEditorState(schema, translator, input.value, upload, previewUrl),

    /**
     * Call input.onChange with the translated content after updating
     * the Prosemiror state.
     * @param tr
     */
    dispatchTransaction: function dispatchTransaction(tr) {
      var nextState = view.state.apply(tr);
      view.updateState(nextState);
      setEditorView({
        view: view
      });

      if (tr.docChanged) {
        input.onChange(translator.stringFromNode(tr.doc));
      }
    }
  });
  setEditorView({
    view: view
  });
  return {
    translator: translator
  };
};

var EditorStateContext = /*#__PURE__*/createContext({
  editorView: undefined,
  translator: undefined
});

var EditorStateProvider = function EditorStateProvider(_ref) {
  var children = _ref.children,
      input = _ref.input,
      el = _ref.el,
      imageProps = _ref.imageProps,
      format = _ref.format;

  var _useState = useState(),
      editorView = _useState[0],
      setEditorView = _useState[1];

  var _useState2 = useState(),
      translator = _useState2[0],
      setTranslator = _useState2[1];

  useEffect(function () {
    setTranslator(buildEditor(input, el, imageProps, setEditorView, format));
    return function () {
      editorView && editorView.view.destroy();
    };
  }, [el]);
  return createElement(EditorStateContext.Provider, {
    value: {
      editorView: editorView,
      translator: translator
    }
  }, children);
};

var useEditorStateContext = function useEditorStateContext() {
  return _extends({}, useContext(EditorStateContext));
};

function _templateObject2$7() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 50%;\n  left: -8px;\n  transform: translate3d(-100%, -50%, 0);\n"]);

  _templateObject2$7 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$9() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  left: 50%;\n  position: absolute;\n  top: -8px;\n  transform: translate3d(-50%, -100%, 0);\n  button:not(:first-of-type) {\n    margin-left: 10px;\n  }\n"]);

  _templateObject$9 = function _templateObject() {
    return data;
  };

  return data;
}

var alignColumn = function alignColumn(view, alignValue) {
  var state = view.state,
      dispatch = view.dispatch;
  var selection = state.selection;
  var _state$schema$nodes = state.schema.nodes,
      table = _state$schema$nodes.table,
      table_cell = _state$schema$nodes.table_cell,
      table_header = _state$schema$nodes.table_header;
  var tableCell = findParentNodeOfType(table_cell)(state.selection);
  var tableHeader = findParentNodeOfType(table_header)(state.selection);
  var cellNode = tableCell || tableHeader;
  if (!cellNode) return;
  var align = cellNode.node.attrs.align === alignValue ? undefined : alignValue;
  var tableNode = findParentNodeOfType(table)(state.selection);
  if (!tableNode) return;
  var tableMap = TableMap.get(tableNode.node);
  var pos = Object.entries(tableMap.map).find(function (entry) {
    return entry[1] > selection.head - tableNode.start;
  });
  if (!pos) return;
  var cellPos = parseInt(pos[0]) - 1;
  var columnPos = cellPos % tableMap.width;
  dispatch(forEachCellInColumn(columnPos, function (cell, tr) {
    return setCellAttrs(cell, {
      align: align
    })(tr);
  })(state.tr));
  view.focus();
};

var ColumnPopup = function ColumnPopup() {
  var _useEditorStateContex = useEditorStateContext(),
      editorView = _useEditorStateContex.editorView;

  if (!editorView) return null;
  var _editorView$view = editorView.view,
      state = _editorView$view.state,
      dispatch = _editorView$view.dispatch;
  var markerDivTable = document.getElementsByClassName('tina_table_header_ext_top_left_selected')[0];
  if (markerDivTable) return null;
  var markerDivCol = document.getElementsByClassName('tina_table_header_ext_top_selected')[0];
  var markerDivRows = document.getElementsByClassName('tina_table_header_ext_left');
  var markerDivRow;

  for (var i = 1; i < markerDivRows.length; i++) {
    if (markerDivRows[i].classList.contains('tina_table_header_ext_left_selected')) markerDivRow = markerDivRows[i];
  }

  if (!markerDivCol && !markerDivRow) return null;
  var view = editorView.view;
  return createElement(Fragment, null, markerDivCol && createPortal(createElement(IconWrapperCol, null, createElement(IconButton, {
    onClick: function onClick() {
      return alignColumn(view, 'left');
    },
    small: true,
    primary: true
  }, createElement(AlignLeft, null)), createElement(IconButton, {
    onClick: function onClick() {
      return alignColumn(view, 'center');
    },
    small: true,
    primary: true
  }, createElement(AlignCenter, null)), createElement(IconButton, {
    onClick: function onClick() {
      return alignColumn(view, 'right');
    },
    small: true,
    primary: true
  }, createElement(AlignRight, null)), createElement(IconButton, {
    onClick: function onClick() {
      deleteColumn(state, dispatch);
      view.focus();
    },
    small: true,
    primary: true
  }, createElement(TrashIcon, null))), markerDivCol), markerDivRow && createPortal(createElement(IconWrapperRow, null, createElement(IconButton, {
    onClick: function onClick() {
      deleteRow(state, dispatch);
      view.focus();
    },
    small: true,
    primary: true
  }, createElement(TrashIcon, null))), markerDivRow));
};

var IconWrapperCol = /*#__PURE__*/styled.span( /*#__PURE__*/_templateObject$9());
var IconWrapperRow = /*#__PURE__*/styled.span( /*#__PURE__*/_templateObject2$7());

function _templateObject4$4() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  background: #0574e4;\n  top: ", "px;\n  z-index: 1000;\n  right: ", "px;\n  width: ", "px;\n  height: ", ";\n"]);

  _templateObject4$4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$5() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translate3d(-50%, -50%, 0);\n"]);

  _templateObject3$5 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$8() {
  var data = _taggedTemplateLiteralLoose(["\n  background: #e1ddec;\n  border-radius: 50%;\n  height: 4px;\n  width: 4px;\n"]);

  _templateObject2$8 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$a() {
  var data = _taggedTemplateLiteralLoose(["\n  top: -7px;\n  position: absolute;\n  right: 0;\n  padding: 8px;\n  transform: translate3d(50%, -100%, 0);\n  user-select: none;\n"]);

  _templateObject$a = function _templateObject() {
    return data;
  };

  return data;
}

var borderWidth = 1;
var controlSize = 12;

var AddColumn = function AddColumn(_ref) {
  var index = _ref.index,
      marker = _ref.marker,
      tableHeight = _ref.tableHeight,
      view = _ref.view;
  var state = view.state,
      dispatch = view.dispatch;

  var addColumn = function addColumn(pos) {
    dispatch(addColumnAt(pos)(state.tr));
    view.focus();
  };

  var _useState = useState(false),
      hovered = _useState[0],
      setHovered = _useState[1];

  useEffect(function () {
    if (hovered) marker.style.zIndex = '1000';else marker.style.zIndex = '1';
  }, [hovered]);
  return createPortal(React__default.createElement(React__default.Fragment, null, React__default.createElement(Wrapper, {
    onMouseEnter: function onMouseEnter() {
      return setHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHovered(false);
    }
  }, hovered ? React__default.createElement(IconWrapperCol$1, null, React__default.createElement(IconButton, {
    onClick: function onClick() {
      addColumn(index);
      setHovered(false);
    },
    small: true,
    primary: true
  }, React__default.createElement(AddIcon, null))) : React__default.createElement(Pointer, null)), hovered && React__default.createElement(ColumnDivider, {
    height: tableHeight
  })), marker);
};

var Wrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$a());
var Pointer = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$8());
var IconWrapperCol$1 = /*#__PURE__*/styled.span( /*#__PURE__*/_templateObject3$5());
var ColumnDivider = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject4$4(), -1 * borderWidth, -1 * borderWidth, 2 * borderWidth, function (_ref2) {
  var height = _ref2.height;
  return height + controlSize - borderWidth + "px";
});

function _templateObject4$5() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  background: #0574e4;\n  left: ", "px;\n  z-index: var(--tina-z-index-1);\n  bottom: ", "px;\n  height: ", "px;\n  width: ", ";\n"]);

  _templateObject4$5 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$6() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 50%;\n  left: 0;\n  transform: translate3d(-50%, -50%, 0);\n"]);

  _templateObject3$6 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$9() {
  var data = _taggedTemplateLiteralLoose(["\n  background: #e1ddec;\n  border-radius: 50%;\n  height: 4px;\n  width: 4px;\n"]);

  _templateObject2$9 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$b() {
  var data = _taggedTemplateLiteralLoose(["\n  left: -7px;\n  position: absolute;\n  bottom: 0;\n  padding: 8px;\n  transform: translate3d(-100%, 50%, 0);\n  user-select: none;\n"]);

  _templateObject$b = function _templateObject() {
    return data;
  };

  return data;
}

var borderWidth$1 = 1;
var controlSize$1 = 12;

var AddRow = function AddRow(_ref) {
  var index = _ref.index,
      marker = _ref.marker,
      tableWidth = _ref.tableWidth,
      view = _ref.view;
  var state = view.state,
      dispatch = view.dispatch;

  var addRow = function addRow(pos) {
    if (pos > 1) dispatch(addRowAt(pos, true)(state.tr));else {
      var _state$schema$nodes = state.schema.nodes,
          table = _state$schema$nodes.table,
          table_cell = _state$schema$nodes.table_cell,
          table_row = _state$schema$nodes.table_row;
      var tableNode = findParentNodeOfType(table)(state.selection);
      if (!tableNode) return;
      var tableMap = TableMap.get(tableNode.node);
      var position = tableNode.start + tableMap.map[tableMap.width] - 1;
      var cellInNextRow = getCellsInRow(0)(state.selection);
      if (!cellInNextRow) return;
      var cells = cellInNextRow === null || cellInNextRow === void 0 ? void 0 : cellInNextRow.map(function (cell) {
        return table_cell.createAndFill(_extends({}, cell.node.attrs));
      });
      dispatch(state.tr.insert(position, table_row.create(null, cells)));
    }
    view.focus();
  };

  var _useState = useState(false),
      hovered = _useState[0],
      setHovered = _useState[1];

  useEffect(function () {
    if (hovered) marker.style.zIndex = '1000';else marker.style.zIndex = '1';
  }, [hovered]);
  return createPortal(React__default.createElement(React__default.Fragment, null, React__default.createElement(Wrapper$1, {
    onMouseEnter: function onMouseEnter() {
      return setHovered(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHovered(false);
    }
  }, hovered && index > 0 ? React__default.createElement(IconWrapperRow$1, null, React__default.createElement(IconButton, {
    onClick: function onClick() {
      return addRow(index);
    },
    small: true,
    primary: true
  }, React__default.createElement(AddIcon, null))) : React__default.createElement(Pointer$1, null)), hovered && React__default.createElement(ColumnDivider$1, {
    width: tableWidth
  })), marker);
};

var Wrapper$1 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$b());
var Pointer$1 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$9());
var IconWrapperRow$1 = /*#__PURE__*/styled.span( /*#__PURE__*/_templateObject3$6());
var ColumnDivider$1 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject4$5(), -1 * borderWidth$1, -1 * borderWidth$1, 2 * borderWidth$1, function (_ref2) {
  var width = _ref2.width;
  return width + controlSize$1 - borderWidth$1 + "px";
});
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

var AddPopup = function AddPopup() {
  var _useEditorStateContex = useEditorStateContext(),
      editorView = _useEditorStateContex.editorView;

  if (!editorView) return null;
  var markerDivTable = document.getElementsByClassName('tina_table_header_ext_top_left');
  if (!markerDivTable.length) return null;
  var tableElm = markerDivTable[0].closest('table');
  if (!tableElm) return null;

  var _tableElm$getBounding = tableElm.getBoundingClientRect(),
      height = _tableElm$getBounding.height,
      width = _tableElm$getBounding.width;

  var markerDivCol = document.getElementsByClassName('tina_table_header_ext_top');
  var markerCols = [markerDivTable[0]];

  for (var i = 0; i < markerDivCol.length; i++) {
    markerCols.push(markerDivCol[i]);
  }

  var markerDivRow = document.getElementsByClassName('tina_table_header_ext_left');
  var markerRows = [markerDivTable[0]];

  for (var _i = 0; _i < markerDivRow.length; _i++) {
    markerRows.push(markerDivRow[_i]);
  }

  var view = editorView.view;
  return React__default.createElement(React__default.Fragment, null, markerCols.map(function (marker, index) {
    return React__default.createElement(AddColumn, {
      key: "add-column-menu-" + index,
      index: index,
      marker: marker,
      tableHeight: height,
      view: view
    });
  }), markerRows.map(function (marker, index) {
    return React__default.createElement(AddRow, {
      key: "add-row-menu-" + index,
      index: index,
      marker: marker,
      tableWidth: width,
      view: view
    });
  }));
};

function _templateObject$c() {
  var data = _taggedTemplateLiteralLoose(["\n  background-color: #ffffff;\n  border-radius: 2px;\n  cursor: default;\n  padding: 0px 4px;\n  position: absolute;\n  top: ", ";\n  left: ", ";\n"]);

  _templateObject$c = function _templateObject() {
    return data;
  };

  return data;
}

var OptionsPopup = function OptionsPopup() {
  var _useEditorStateContex = useEditorStateContext(),
      editorView = _useEditorStateContex.editorView;

  if (!editorView) return null;
  var view = editorView.view;

  var deleteSelectedTable = function deleteSelectedTable() {
    var state = view.state,
        dispatch = view.dispatch;
    deleteTable(state, dispatch);
    view.focus();
  };

  var markerDivTable = document.getElementsByClassName('tina_table_header_ext_top_left');
  if (!markerDivTable.length) return null;
  var tableElm = markerDivTable[0].closest('table');
  if (!tableElm) return null;

  var _tableElm$getBounding = tableElm.getBoundingClientRect(),
      height = _tableElm$getBounding.height,
      width = _tableElm$getBounding.width;

  return ReactDOM__default.createPortal(React__default.createElement(Wrapper$2, {
    height: height,
    width: width
  }, React__default.createElement(IconButton, {
    onClick: deleteSelectedTable,
    small: true,
    primary: true
  }, React__default.createElement(TrashIcon, null))), markerDivTable[0]);
};

var Wrapper$2 = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$c(), function (_ref) {
  var height = _ref.height;
  return height + 24 + "px";
}, function (_ref2) {
  var width = _ref2.width;
  return width / 2 - 8 + "px";
});
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

var TablePopups = function TablePopups() {
  return createElement(Fragment, null, createElement(ColumnPopup, null), createElement(AddPopup, null), createElement(OptionsPopup, null));
};

function blockTool(options) {
  var Component$1 = options.Component,
      children = options.children,
      command = options.command,
      typeName = options.typeName,
      attrs = options.attrs;
  return /*#__PURE__*/function (_React$Component) {
    _inheritsLoose(_class, _React$Component);

    function _class() {
      var _this;

      _this = _React$Component.apply(this, arguments) || this;

      _this.canDo = function () {
        return command(_this.props.view.state);
      };

      _this.onClick = function () {
        command(_this.props.view.state, _this.props.view.dispatch);

        _this.props.view.focus();

        _this.props.onClick();
      };

      return _this;
    }

    var _proto = _class.prototype;

    _proto.render = function render() {
      return createElement(MenuOption, {
        onClick: this.onClick,
        disabled: !this.canDo(),
        active: this.active
      }, createElement(Component$1, null, children));
    };

    _createClass(_class, [{
      key: "active",
      get: function get() {
        if (!typeName) return false;
        var state = this.props.view.state;
        var $from = state.selection.$from;
        var node = $from.node($from.depth);
        var correctNodeType = node.type.name === typeName; // Only works for Heading

        var correctAttrs = attrs ? node.attrs.level === attrs.level : true;
        return correctNodeType && correctAttrs;
      }
    }]);

    return _class;
  }(Component);
}

function _templateObject7$3() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject7$3 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6$3() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject6$3 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5$3() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject5$3 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4$6() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject4$6 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$7() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject3$7 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$a() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n"]);

  _templateObject2$a = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$d() {
  var data = _taggedTemplateLiteralLoose(["\n  white-space: nowrap;\n  line-height: 1;\n  display: block;\n  margin: 0;\n"]);

  _templateObject$d = function _templateObject() {
    return data;
  };

  return data;
}

var Menu$5 = function Menu() {
  var _useState = useState(false),
      active = _useState[0],
      setActive = _useState[1];

  var menuButtonRef = useRef();

  var _useEditorStateContex = useEditorStateContext(),
      editorView = _useEditorStateContex.editorView;

  var view = editorView.view;

  var toggle = function toggle() {
    return setActive(!active);
  };

  return createElement(Fragment, null, createElement(MenuButton, {
    ref: menuButtonRef,
    "data-tooltip": 'Heading',
    onClick: toggle,
    active: active
  }, createElement(HeadingIcon, null)), createElement(MenuDropdown, {
    triggerRef: menuButtonRef,
    open: active
  }, createElement(Dismissible, {
    click: true,
    escape: true,
    disabled: !active,
    onDismiss: toggle
  }, createElement(H1, {
    view: view,
    onClick: toggle
  }), createElement(H2, {
    view: view,
    onClick: toggle
  }), createElement(H3, {
    view: view,
    onClick: toggle
  }), createElement(H4, {
    view: view,
    onClick: toggle
  }), createElement(H5, {
    view: view,
    onClick: toggle
  }), createElement(H6, {
    view: view,
    onClick: toggle
  }))));
};

function makeToggleHeader(level) {
  return function toggleHeader$1(state, dispatch) {
    var tn = toggleHeader(state.schema.nodes.heading, {
      level: level
    }, state.schema.nodes.paragraph, null);
    return tn(state, dispatch);
  };
}

var BaseHeading = /*#__PURE__*/css( /*#__PURE__*/_templateObject$d());
var HeadingOne = /*#__PURE__*/styled.h1( /*#__PURE__*/_templateObject2$a(), BaseHeading);
var HeadingTwo = /*#__PURE__*/styled.h2( /*#__PURE__*/_templateObject3$7(), BaseHeading);
var HeadingThree = /*#__PURE__*/styled.h3( /*#__PURE__*/_templateObject4$6(), BaseHeading);
var HeadingFour = /*#__PURE__*/styled.h4( /*#__PURE__*/_templateObject5$3(), BaseHeading);
var HeadingFive = /*#__PURE__*/styled.h5( /*#__PURE__*/_templateObject6$3(), BaseHeading);
var HeadingSix = /*#__PURE__*/styled.h6( /*#__PURE__*/_templateObject7$3(), BaseHeading);
var H1 = /*#__PURE__*/blockTool({
  Component: HeadingOne,
  children: 'Heading 1',
  command: /*#__PURE__*/makeToggleHeader(1),
  typeName: 'heading',
  attrs: {
    level: 1
  }
});
var H2 = /*#__PURE__*/blockTool({
  Component: HeadingTwo,
  children: 'Heading 2',
  command: /*#__PURE__*/makeToggleHeader(2),
  typeName: 'heading',
  attrs: {
    level: 2
  }
});
var H3 = /*#__PURE__*/blockTool({
  Component: HeadingThree,
  children: 'Heading 3',
  command: /*#__PURE__*/makeToggleHeader(3),
  typeName: 'heading',
  attrs: {
    level: 3
  }
});
var H4 = /*#__PURE__*/blockTool({
  Component: HeadingFour,
  children: 'Heading 4',
  command: /*#__PURE__*/makeToggleHeader(4),
  typeName: 'heading',
  attrs: {
    level: 4
  }
});
var H5 = /*#__PURE__*/blockTool({
  Component: HeadingFive,
  children: 'Heading 5',
  command: /*#__PURE__*/makeToggleHeader(5),
  typeName: 'heading',
  attrs: {
    level: 5
  }
});
var H6 = /*#__PURE__*/blockTool({
  Component: HeadingSix,
  children: 'Heading 6',
  command: /*#__PURE__*/makeToggleHeader(6),
  typeName: 'heading',
  attrs: {
    level: 6
  }
});
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

var Menu$6 = function Menu() {
  return createElement(Fragment, null, createElement(UndoControl, null), createElement(RedoControl, null));
};

var UndoControl = function UndoControl() {
  var _useEditorStateContex = useEditorStateContext(),
      editorView = _useEditorStateContex.editorView;

  var undoChange = function undoChange() {
    var _editorView$view = editorView.view,
        state = _editorView$view.state,
        dispatch = _editorView$view.dispatch;
    undo(state, dispatch);
  };

  return createElement(MenuButton, {
    "data-tooltip": "Undo",
    "data-side": "top",
    onClick: undoChange,
    disabled: undoDepth(editorView.view.state) < 1
  }, createElement(UndoIcon, null));
};

var RedoControl = function RedoControl() {
  var _useEditorStateContex2 = useEditorStateContext(),
      editorView = _useEditorStateContex2.editorView;

  var redoChange = function redoChange() {
    var _editorView$view2 = editorView.view,
        state = _editorView$view2.state,
        dispatch = _editorView$view2.dispatch;
    redo(state, dispatch);
  };

  return createElement(MenuButton, {
    "data-tooltip": "Redo",
    "data-side": "top",
    onClick: redoChange,
    disabled: redoDepth(editorView.view.state) < 1
  }, createElement(RedoIcon, null));
};
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/


var Menu$7 = function Menu(props) {
  return createElement(Fragment, null, createElement(BulletList, Object.assign({}, props)), createElement(OrderedList, Object.assign({}, props)));
};

var BulletList = /*#__PURE__*/commandControl(toggleBulletList, UnorderedListIcon, 'Unordered List', 'Unordered List');
var OrderedList = /*#__PURE__*/commandControl(toggleOrderedList, OrderedListIcon, 'Ordered List', 'Ordered List');
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

function wrapInBlockquote(state, dispatch) {
  var blockquote = state.schema.nodes.blockquote;

  var _ref = findParentNodeOfType(blockquote)(state.selection) || {},
      start = _ref.start,
      node = _ref.node;

  if (start && node) {
    var tr = state.tr;
    var nodeRange = tr.doc.resolve(start + 1).blockRange(tr.doc.resolve(start + node.nodeSize - 2));

    if (nodeRange) {
      if (dispatch) return dispatch(tr.lift(nodeRange, 0));else return true;
    }
  }

  return wrapIn(state.schema.nodes.blockquote)(state, dispatch);
}

var Menu$8 = /*#__PURE__*/commandControl(wrapInBlockquote, QuoteIcon, 'Blockquote', 'Blockquote');

function _templateObject4$7() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  position: relative;\n  top: 0;\n  width: 100%;\n  background-color: white;\n  border-radius: var(--tina-radius-small);\n  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.12);\n  border: 1px solid var(--tina-color-grey-2);\n  overflow: hidden;\n  z-index: var(--tina-z-index-0);\n"]);

  _templateObject4$7 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$8() {
  var data = _taggedTemplateLiteralLoose(["\n      position: fixed;\n      width: ", "px;\n      top: ", ";\n    "]);

  _templateObject3$8 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$b() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  margin-bottom: 14px;\n  z-index: var(--tina-z-index-1);\n\n  ", ";\n"]);

  _templateObject2$b = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$e() {
  var data = _taggedTemplateLiteralLoose(["\n  color: transparent;\n  background: transparent;\n  pointer-events: none;\n  position: relative;\n  display: block;\n  height: ", "px;\n  width: ", "px;\n"]);

  _templateObject$e = function _templateObject() {
    return data;
  };

  return data;
}

var MenuPlaceholder = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject$e(), function (props) {
  return props.menuBoundingBox.height;
}, function (props) {
  return props.menuBoundingBox.width;
});
var MenuWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$b(), function (props) {
  return props.menuFixed && css(_templateObject3$8(), props.menuBoundingBox.width, props.menuFixedTopOffset);
});
var MenuContainer = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject4$7());
/**

Copyright 2019 Forestry.io Inc

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

var Menubar = function Menubar(_ref) {
  var _ref$sticky = _ref.sticky,
      sticky = _ref$sticky === void 0 ? true : _ref$sticky,
      uploadImages = _ref.uploadImages;

  var _useState = useState(false),
      menuFixed = _useState[0],
      setMenuFixed = _useState[1];

  var isBrowser = typeof window !== "undefined";
  var menuRef = useRef(null);

  var _useState2 = useState(null),
      menuBoundingBox = _useState2[0],
      setMenuBoundingBox = _useState2[1];

  var menuFixedTopOffset = typeof sticky === 'string' ? sticky : '0';

  var _useEditorStateContex = useEditorStateContext(),
      editorView = _useEditorStateContex.editorView;

  useEffect(function () {
    if (menuRef.current && sticky) {
      setMenuBoundingBox(menuRef.current.getBoundingClientRect());
    }
  }, [menuRef, editorView]);
  useLayoutEffect(function () {
    if (!isBrowser || !menuRef.current || !sticky) {
      return;
    }

    var handleScroll = function handleScroll() {
      var wysiwygWrapper = menuRef.current.parentElement;
      var startPosition = wysiwygWrapper ? wysiwygWrapper.offsetTop : 0;
      var endPosition = wysiwygWrapper ? startPosition + wysiwygWrapper.offsetHeight : 0;

      if (window.scrollY > startPosition && window.scrollY < endPosition) {
        setMenuFixed(true);
      } else {
        setMenuFixed(false);
      }
    };

    var handleResize = function handleResize() {
      if (menuRef.current) {
        var wasMenuFixed = menuFixed;
        setMenuFixed(false);
        setMenuBoundingBox(menuRef.current.getBoundingClientRect());
        setMenuFixed(wasMenuFixed);
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, [menuRef, menuBoundingBox]);
  var preventProsemirrorFocusLoss = React__default.useCallback(function (e) {
    e.stopPropagation();
    e.preventDefault();
  }, []);
  if (!editorView) return null;
  return React__default.createElement(React__default.Fragment, null, menuFixed && React__default.createElement(MenuPlaceholder, {
    menuBoundingBox: menuBoundingBox
  }), React__default.createElement(MenuWrapper, {
    menuFixedTopOffset: menuFixedTopOffset,
    menuFixed: menuFixed,
    menuBoundingBox: menuBoundingBox,
    ref: menuRef
  }, React__default.createElement(MenuPortalProvider, null, React__default.createElement(MenuContainer, {
    onMouseDown: preventProsemirrorFocusLoss
  }, React__default.createElement(Menu$5, null), React__default.createElement(Menu$2, null), React__default.createElement(Menu$3, null), React__default.createElement(Menu, {
    uploadImages: uploadImages
  }), React__default.createElement(Menu$4, null), React__default.createElement(Menu$8, null), React__default.createElement(Menu$1, null), React__default.createElement(Menu$7, null), React__default.createElement(Menu$6, null)))), React__default.createElement(TablePopups, null), React__default.createElement(ImageEdit, null), React__default.createElement(LinkForm, null), React__default.createElement(Loader, null));
}; // todo: sub-menus to return null if schema does not have related type of node / mark.


function _templateObject$f() {
  var data = _taggedTemplateLiteralLoose(["\n  white-space: pre-wrap;\n\n  .CodeMirror {\n    font-family: monospace;\n    height: auto;\n    width: 100%;\n    border-radius: 5px;\n    margin-bottom: 16px;\n    color: black;\n    direction: ltr;\n  }\n\n  .CodeMirror-lines {\n    padding: 4px 0; /* Vertical padding around content */\n  }\n  .CodeMirror pre.CodeMirror-line,\n  .CodeMirror pre.CodeMirror-line-like {\n    padding: 0 4px; /* Horizontal padding of content */\n  }\n\n  .CodeMirror-scrollbar-filler,\n  .CodeMirror-gutter-filler {\n    background-color: white; /* The little square between H and V scrollbars */\n  }\n\n  /* GUTTER */\n\n  .CodeMirror-gutters {\n    border-right: 1px solid #ddd;\n    background-color: #f7f7f7;\n    white-space: nowrap;\n  }\n  .CodeMirror-linenumbers {\n  }\n  .CodeMirror-linenumber {\n    padding: 0 3px 0 5px;\n    min-width: 20px;\n    text-align: right;\n    color: #999;\n    white-space: nowrap;\n  }\n\n  .CodeMirror-guttermarker {\n    color: black;\n  }\n  .CodeMirror-guttermarker-subtle {\n    color: #999;\n  }\n\n  /* CURSOR */\n\n  .CodeMirror-cursor {\n    border-left: 1px solid black;\n    border-right: none;\n    width: 0;\n  }\n  /* Shown when moving in bi-directional text */\n  .CodeMirror div.CodeMirror-secondarycursor {\n    border-left: 1px solid silver;\n  }\n  .cm-fat-cursor .CodeMirror-cursor {\n    width: auto;\n    border: 0 !important;\n    background: #7e7;\n  }\n  .cm-fat-cursor div.CodeMirror-cursors {\n    z-index: 1;\n  }\n  .cm-fat-cursor-mark {\n    background-color: rgba(20, 255, 20, 0.5);\n    -webkit-animation: blink 1.06s steps(1) infinite;\n    -moz-animation: blink 1.06s steps(1) infinite;\n    animation: blink 1.06s steps(1) infinite;\n  }\n  .cm-animate-fat-cursor {\n    width: auto;\n    border: 0;\n    -webkit-animation: blink 1.06s steps(1) infinite;\n    -moz-animation: blink 1.06s steps(1) infinite;\n    animation: blink 1.06s steps(1) infinite;\n    background-color: #7e7;\n  }\n  @-moz-keyframes blink {\n    0% {\n    }\n    50% {\n      background-color: transparent;\n    }\n    100% {\n    }\n  }\n  @-webkit-keyframes blink {\n    0% {\n    }\n    50% {\n      background-color: transparent;\n    }\n    100% {\n    }\n  }\n  @keyframes blink {\n    0% {\n    }\n    50% {\n      background-color: transparent;\n    }\n    100% {\n    }\n  }\n\n  /* Can style cursor different in overwrite (non-insert) mode */\n  .CodeMirror-overwrite .CodeMirror-cursor {\n  }\n\n  .cm-tab {\n    display: inline-block;\n    text-decoration: inherit;\n  }\n\n  .CodeMirror-rulers {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: -50px;\n    bottom: 0;\n    overflow: hidden;\n  }\n  .CodeMirror-ruler {\n    border-left: 1px solid #ccc;\n    top: 0;\n    bottom: 0;\n    position: absolute;\n  }\n\n  /* DEFAULT THEME */\n\n  .cm-s-default .cm-header {\n    color: blue;\n  }\n  .cm-s-default .cm-quote {\n    color: #090;\n  }\n  .cm-negative {\n    color: #d44;\n  }\n  .cm-positive {\n    color: #292;\n  }\n  .cm-header,\n  .cm-strong {\n    font-weight: bold;\n  }\n  .cm-em {\n    font-style: italic;\n  }\n  .cm-link {\n    text-decoration: underline;\n  }\n  .cm-strikethrough {\n    text-decoration: line-through;\n  }\n\n  .cm-s-default .cm-keyword {\n    color: #708;\n  }\n  .cm-s-default .cm-atom {\n    color: #219;\n  }\n  .cm-s-default .cm-number {\n    color: #164;\n  }\n  .cm-s-default .cm-def {\n    color: #00f;\n  }\n  .cm-s-default .cm-variable,\n  .cm-s-default .cm-punctuation,\n  .cm-s-default .cm-property,\n  .cm-s-default .cm-operator {\n  }\n  .cm-s-default .cm-variable-2 {\n    color: #05a;\n  }\n  .cm-s-default .cm-variable-3,\n  .cm-s-default .cm-type {\n    color: #085;\n  }\n  .cm-s-default .cm-comment {\n    color: #a50;\n  }\n  .cm-s-default .cm-string {\n    color: #a11;\n  }\n  .cm-s-default .cm-string-2 {\n    color: #f50;\n  }\n  .cm-s-default .cm-meta {\n    color: #555;\n  }\n  .cm-s-default .cm-qualifier {\n    color: #555;\n  }\n  .cm-s-default .cm-builtin {\n    color: #30a;\n  }\n  .cm-s-default .cm-bracket {\n    color: #997;\n  }\n  .cm-s-default .cm-tag {\n    color: #170;\n  }\n  .cm-s-default .cm-attribute {\n    color: #00c;\n  }\n  .cm-s-default .cm-hr {\n    color: #999;\n  }\n  .cm-s-default .cm-link {\n    color: #00c;\n  }\n\n  .cm-s-default .cm-error {\n    color: #f00;\n  }\n  .cm-invalidchar {\n    color: #f00;\n  }\n\n  .CodeMirror-composing {\n    border-bottom: 2px solid;\n  }\n\n  /* Default styles for common addons */\n\n  div.CodeMirror span.CodeMirror-matchingbracket {\n    color: #0b0;\n  }\n  div.CodeMirror span.CodeMirror-nonmatchingbracket {\n    color: #a22;\n  }\n  .CodeMirror-matchingtag {\n    background: rgba(255, 150, 0, 0.3);\n  }\n  .CodeMirror-activeline-background {\n    background: #e8f2ff;\n  }\n\n  /* STOP */\n\n  /* The rest of this file contains styles related to the mechanics of\n    the editor. You probably shouldn't touch them. */\n\n  .CodeMirror {\n    position: relative;\n    overflow: hidden;\n    background: white;\n  }\n\n  .CodeMirror-scroll {\n    overflow: scroll !important; /* Things will break if this is overridden */\n    /* 30px is the magic margin used to hide the element's real scrollbars */\n    /* See overflow: hidden in .CodeMirror */\n    margin-bottom: -30px;\n    margin-right: -30px;\n    padding-bottom: 30px;\n    height: 100%;\n    outline: none; /* Prevent dragging from highlighting the element */\n    position: relative;\n  }\n  .CodeMirror-sizer {\n    position: relative;\n    min-height: auto;\n    border-right: 30px solid transparent;\n  }\n\n  /* The fake, visible scrollbars. Used to force redraw during scrolling\n    before actual scrolling happens, thus preventing shaking and\n    flickering artifacts. */\n  .CodeMirror-vscrollbar,\n  .CodeMirror-hscrollbar,\n  .CodeMirror-scrollbar-filler,\n  .CodeMirror-gutter-filler {\n    position: absolute;\n    z-index: 6;\n    display: none;\n  }\n  .CodeMirror-vscrollbar {\n    right: 0;\n    top: 0;\n    overflow-x: hidden;\n    overflow-y: scroll;\n  }\n  .CodeMirror-hscrollbar {\n    bottom: 0;\n    left: 0;\n    overflow-y: hidden;\n    overflow-x: scroll;\n  }\n  .CodeMirror-scrollbar-filler {\n    right: 0;\n    bottom: 0;\n  }\n  .CodeMirror-gutter-filler {\n    left: 0;\n    bottom: 0;\n  }\n\n  .CodeMirror-gutters {\n    position: absolute;\n    left: 0;\n    top: 0;\n    min-height: 100%;\n    z-index: 3;\n  }\n  .CodeMirror-gutter {\n    white-space: normal;\n    height: 100%;\n    display: inline-block;\n    vertical-align: top;\n    margin-bottom: -30px;\n  }\n  .CodeMirror-gutter-wrapper {\n    position: absolute;\n    z-index: 4;\n    background: none !important;\n    border: none !important;\n  }\n  .CodeMirror-gutter-background {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    z-index: 4;\n  }\n  .CodeMirror-gutter-elt {\n    position: absolute;\n    cursor: default;\n    z-index: 4;\n  }\n  .CodeMirror-gutter-wrapper ::selection {\n    background-color: transparent;\n  }\n  .CodeMirror-gutter-wrapper ::-moz-selection {\n    background-color: transparent;\n  }\n\n  .CodeMirror-lines {\n    cursor: text;\n    min-height: 1px; /* prevents collapsing before first draw */\n  }\n  .CodeMirror pre.CodeMirror-line,\n  .CodeMirror pre.CodeMirror-line-like {\n    /* Reset some styles that the rest of the page might have set */\n    -moz-border-radius: 0;\n    -webkit-border-radius: 0;\n    border-radius: 0;\n    border-width: 0;\n    background: transparent;\n    font-family: inherit;\n    font-size: inherit;\n    margin: 0;\n    white-space: pre;\n    word-wrap: normal;\n    line-height: inherit;\n    color: inherit;\n    z-index: 2;\n    position: relative;\n    overflow: visible;\n    -webkit-tap-highlight-color: transparent;\n    -webkit-font-variant-ligatures: contextual;\n    font-variant-ligatures: contextual;\n  }\n  .CodeMirror-wrap pre.CodeMirror-line,\n  .CodeMirror-wrap pre.CodeMirror-line-like {\n    word-wrap: break-word;\n    white-space: pre-wrap;\n    word-break: normal;\n  }\n\n  .CodeMirror-linebackground {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    z-index: 0;\n  }\n\n  .CodeMirror-linewidget {\n    position: relative;\n    z-index: 2;\n    padding: 0.1px; /* Force widget margins to stay inside of the container */\n  }\n\n  .CodeMirror-widget {\n  }\n\n  .CodeMirror-rtl pre {\n    direction: rtl;\n  }\n\n  .CodeMirror-code {\n    outline: none;\n  }\n\n  /* Force content-box sizing for the elements where we expect it */\n  .CodeMirror-scroll,\n  .CodeMirror-sizer,\n  .CodeMirror-gutter,\n  .CodeMirror-gutters,\n  .CodeMirror-linenumber {\n    -moz-box-sizing: content-box;\n    box-sizing: content-box;\n  }\n\n  .CodeMirror-measure {\n    position: absolute;\n    width: 100%;\n    height: 0;\n    overflow: hidden;\n    visibility: hidden;\n  }\n\n  .CodeMirror-cursor {\n    position: absolute;\n    pointer-events: none;\n  }\n  .CodeMirror-measure pre {\n    position: static;\n  }\n\n  div.CodeMirror-cursors {\n    visibility: hidden;\n    position: relative;\n    z-index: 3;\n  }\n  div.CodeMirror-dragcursors {\n    visibility: visible;\n  }\n\n  .CodeMirror-focused div.CodeMirror-cursors {\n    visibility: visible;\n  }\n\n  .CodeMirror-selected {\n    background: #d9d9d9;\n  }\n  .CodeMirror-focused .CodeMirror-selected {\n    background: #d7d4f0;\n  }\n  .CodeMirror-crosshair {\n    cursor: crosshair;\n  }\n  .CodeMirror-line::selection,\n  .CodeMirror-line > span::selection,\n  .CodeMirror-line > span > span::selection {\n    background: #d7d4f0;\n  }\n  .CodeMirror-line::-moz-selection,\n  .CodeMirror-line > span::-moz-selection,\n  .CodeMirror-line > span > span::-moz-selection {\n    background: #d7d4f0;\n  }\n\n  .cm-searching {\n    background-color: #ffa;\n    background-color: rgba(255, 255, 0, 0.4);\n  }\n\n  /* Used to force a border model for a node */\n  .cm-force-border {\n    padding-right: 0.1px;\n  }\n\n  @media print {\n    /* Hide the cursor when printing */\n    .CodeMirror div.CodeMirror-cursors {\n      visibility: hidden;\n    }\n  }\n\n  /* See issue #2901 */\n  .cm-tab-wrap-hack:after {\n    content: '';\n  }\n\n  /* Help users use markselection to safely style text background */\n  span.CodeMirror-selectedtext {\n    background: none;\n  }\n"]);

  _templateObject$f = function _templateObject() {
    return data;
  };

  return data;
}

var CodeMirrorCss = /*#__PURE__*/css( /*#__PURE__*/_templateObject$f());

function _templateObject$g() {
  var data = _taggedTemplateLiteralLoose(["\n  .ProseMirror .tinacms-image-wrapper {\n    display: inline-block;\n    margin: 1em 0;\n  }\n\n  ", "\n"]);

  _templateObject$g = function _templateObject() {
    return data;
  };

  return data;
}

var paddingX = 8;
var paddingY = 6;
var borderWidth$2 = 1;
var controlSize$2 = 12;
var proseMirrorTableStyles = "\n  .ProseMirror {\n    display: inline-block\n  }\n  .ProseMirror .tableWrapper {\n    overflow-x: auto;\n  }\n  .ProseMirror .column-resize-handle {\n    position: absolute;\n    right: -2px;\n    top: 0;\n    bottom: 0;\n    width: 4px;\n    z-index: 20;\n    background-color: #adf;\n    pointer-events: none;\n  }\n  .ProseMirror.resize-cursor {\n    cursor: ew-resize;\n    cursor: col-resize;\n  }\n  /* Give selected cells a blue overlay */\n  .ProseMirror .selectedCell:after {\n    z-index: 2;\n    position: absolute;\n    content: '';\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    background: rgba(0, 132, 255, 0.25);\n    /* This provides a bullet-proof border for selected cells even with border collapsing */\n    box-shadow: 0 0 0 1px #0574E4;\n    pointer-events: none;\n  }\n  .ProseMirror:focus {\n    outline: 0px solid transparent;\n  }\n  .ProseMirror table {\n    border-collapse: collapse;\n    table-layout: fixed;\n    display: inline-table;\n    margin: 32px 0 32px 0;\n    overflow: visible;\n    width: 100%;\n  }\n  .ProseMirror th {\n    background-color: #F6F6F9;\n  }\n  .ProseMirror table td,\n  .ProseMirror table th {\n    border: 1px solid #E1DDEC;\n    padding: " + paddingY + "px " + paddingX + "px;\n    position: relative;\n    vertical-align: top;\n    box-sizing: border-box;\n  }\n  .ProseMirror .tina_table_header_ext_top {\n    background: #F6F6F9;\n    border: 1px solid #E1DDEC;\n    position: absolute;\n    height: " + controlSize$2 + "px;\n    width: calc(100% + " + borderWidth$2 * 2 + "px);\n    transform: translate(" + (borderWidth$2 + paddingX) * -1 + "px, " + (controlSize$2 + paddingY) * -1 + "px);\n    cursor: pointer;\n    z-index: 1;\n    user-select: none;\n    box-sizing: border-box;\n  }\n  .ProseMirror div.tina_table_header_ext_top_selected {\n    background: #0084ff;\n    border-color: #0574E4;\n    z-index: 10;\n  }\n  .ProseMirror .tina_table_header_ext_left {\n    background: #F6F6F9;\n    border: 1px solid #E1DDEC;\n    position: absolute;\n    height: calc(100% + " + borderWidth$2 * 2 + "px);\n    width: " + controlSize$2 + "px;\n    transform: translate(" + (controlSize$2 + paddingX) * -1 + "px, " + (borderWidth$2 + paddingY) * -1 + "px);\n    cursor: pointer;\n    z-index: 1;\n    user-select: none;\n    box-sizing: border-box;\n  }\n  .ProseMirror div.tina_table_header_ext_left_selected {\n    background: #0084ff;\n    border-color: #0574E4;\n    z-index: 10;\n  }\n  .ProseMirror .tina_table_header_ext_top_left {\n    background: #F6F6F9;\n    border: 1px solid #E1DDEC;\n    position: absolute;\n    height: " + controlSize$2 + "px;\n    width: " + controlSize$2 + "px;\n    transform: translate(" + (controlSize$2 + paddingX) * -1 + "px, " + (controlSize$2 + paddingY) * -1 + "px);\n    border-radius: 5px 0 0 0;\n    z-index: 1;\n    cursor: pointer;\n    user-select: none;\n    box-sizing: border-box;\n  }\n  .ProseMirror div.tina_table_header_ext_top_left_selected {\n    background: #0084ff;\n    border-color: #0574E4;\n    z-index: 10;\n  }\n  .ProseMirror .selectedCell {\n    border-color: transparent;\n  }\n";
var ProseMirrorCss = /*#__PURE__*/css( /*#__PURE__*/_templateObject$g(), proseMirrorTableStyles);

function _templateObject2$c() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n"]);

  _templateObject2$c = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$h() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "", "\n"]);

  _templateObject$h = function _templateObject() {
    return data;
  };

  return data;
}

var Wysiwyg = /*#__PURE__*/styled(function (_ref) {
  var input = _ref.input,
      sticky = _ref.sticky,
      format = _ref.format,
      imageProps = _ref.imageProps,
      styleProps = _objectWithoutPropertiesLoose(_ref, ["input", "plugins", "sticky", "format", "imageProps"]);

  var _useState = useState(),
      el = _useState[0],
      setEl = _useState[1];

  var editorRef = useRef(null);
  useEffect(function () {
    // State is updated with latest value of editorRef to trigger re-render
    if (editorRef.current) setEl(editorRef.current);
  }, [editorRef]);
  return createElement(WysiwygWrapper, {
    className: "wysiwyg-wrapper"
  }, createElement("link", {
    rel: "stylesheet",
    href: "https://codemirror.net/lib/codemirror.css"
  }), createElement(EditorStateProvider, {
    input: input,
    el: el,
    imageProps: imageProps,
    format: format
  }, createElement(Menubar, {
    sticky: sticky,
    uploadImages: imageProps && imageProps.upload
  })), createElement("div", Object.assign({}, styleProps, {
    ref: editorRef
  })));
})( /*#__PURE__*/_templateObject$h(), CodeMirrorCss, ProseMirrorCss);
var WysiwygWrapper = /*#__PURE__*/styled.div( /*#__PURE__*/_templateObject2$c());
export { Wysiwyg };